import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Navbar,
  Nav,
  NavItem,
  MenuItem,
  NavDropdown,
  Modal,
  Button
} from "react-bootstrap";
import { ENDPOINTS } from "../constants/endpoints";
// import FileManager from "./UserImgcredit/UserImgcredit";
import FileManager from "../components/FileManager/FileManager";
import logo from "images/Composz-logo-white-trans.png";

import {
  generateProfessionalHeadshot,
  countPeople,
  detectGender,
  validateImageSafety,
  generateGroupPortrait,
  classifySnippetInstruction
} from "./gemini";
import ImageUploader from "./ImageUploader";
import StyleBuilderModal from "./StyleBuilderModal";
import GroupUploaderModal from "./GroupUploaderModal";
import TermsModal from "./TermsModal";
import FAQModal from "./FAQModal";
import DisclaimerModal from "./DisclaimerModal";
import { SPLoader } from "./Spinner.js";

const honorSocieties = [
  { name: "National Honor Society (NHS)", color: "#facc15" }, // Gold
  { name: "National Art Honor Society (NAHS)", color: "#3b82f6" }, // Blue
  { name: "National English Honor Society (NEHS)", color: "#1e3a8a" }, // Dark Blue
  { name: "National Spanish Honor Society", color: "#dc2626" }, // Red
  { name: "National French Honor Society", color: "#2563eb" }, // Royal Blue
  { name: "Mu Alpha Theta (Math)", color: "#60a5fa" }, // Light Blue
  { name: "Science National Honor Society", color: "#10b981" }, // Green
  { name: "Quill and Scroll (Journalism)", color: "#1e40af" }, // Blue/Gold mix usually
  { name: "Tri-M Music Honor Society", color: "#ec4899" }, // Pink
  { name: "Custom / Other", color: "#cbd5e1" }
];

const DEFAULT_OPTIONS = {
  attireMode: "professional",
  keepDress: false,
  keepEyewear: true,
  keepHair: true,
  hairStyle: "keep",
  facialHair: "default",
  keepMustache: false,
  keepFacialChars: true,
  expression: "original",
  posture: "professional",
  lightingMode: "even",
  facingCamera: false,
  isProfileView: false,
  profileDirection: "right",
  profileAngle: 45,
  isCloseup: false,
  closeupIntensity: 50,
  hasHeadroomAdjust: false,
  headroomLevel: 50,
  aspectRatio: "3:4",
  attireType: "suit",
  blazerStyle: "standard",
  attireColor: "#1e293b",
  hasTie: true,
  tieColor: "#991b1b",
  tieStyle: "plain",
  shirtStyle: "solid",
  shirtColor: "#ffffff",
  shirtStripeColor: "#cbd5e1",
  shirtStripeWidth: "thin",
  shirtCheckColor: "#cbd5e1",
  shirtCheckSize: "small",
  vestColor: "#1e293b",
  lapelType: "notch",
  hasBowTie: false,
  bowTieColor: "#000000",
  cummerbundColor: "#000000",
  hasPocketSquare: false,
  pocketSquareColor: "#ffffff",
  blouseStyle: "buttoned-down",
  blouseColor: "#ffffff",
  uniformType: "collar",
  uniformColor: "#0f172a",
  uniformStripeColor: "#ffffff",
  uniformStripeWidth: "thin",
  hasUniformTie: false,
  uniformTieColor: "#991b1b",
  pinaforeShirtColor: "#ffffff",
  pinaforeShirtPattern: "plain",
  pinaforeShirtStripeColor: "#cbd5e1",
  pinaforeShirtStripeWidth: "thin",
  pinaforeShirtSleeves: "short",
  pinaforeSleeveCuff: "plain",
  casualTopType: "tshirt",
  casualTopColor: "#334155",
  casualOuterType: "none",
  casualOuterColor: "#1e293b",
  casualSweaterStyle: "crew-neck",
  blurBgRef: true,
  noBlemishes: false,
  removeHandProps: true,
  removeHandGestures: true,
  subjectBokeh: false,
  subjectBokehDepth: 50,
  isGraduation: false,
  gradStyle: "Bachelors",
  gownColor: "#000000",
  capColor: "#000000",
  hoodColor: "#eab308",
  hasHood: true,
  hasStole: false,
  stoleColor: "#ffffff",
  tasselColor: "#facc15",
  tasselSide: "left",
  tamColor: "#000000",
  sashColor: "#991b1b",
  hasSash: false,
  hasRibbon: false,
  ribbonColor: "#dc2626",
  gradProp: "none",
  gownClosureType: "zipper",
  scrollRibbonColor: "#dc2626",
  hasGradShirt: false,
  gradShirtColor: "#ffffff",
  hasGradTie: false,
  gradTieColor: "#1e293b",
  hasHonorCord: false,
  honorSociety: honorSocieties[0].name,
  honorCordColor: honorSocieties[0].color,
  textOnlyDirective: ""
};

const getCookie = (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

const GenPortraits = (mobile, argImgCredits) => {
  const [hasKey, setHasKey] = useState(true);
  const [mainImage, setMainImage] = useState(null);
  const [maleRef, setMaleRef] = useState(null);
  const [femaleRef, setFemaleRef] = useState(null);
  const [groupStyleRef, setGroupStyleRef] = useState(null);
  const [bgRef, setBgRef] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [isSafe, setIsSafe] = useState(true);
  const [isStyleBuilderOpen, setIsStyleBuilderOpen] = useState(false);
  const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isFAQModalOpen, setIsFAQModalOpen] = useState(false);
  const [isDisclaimerModalOpen, setIsDisclaimerModalOpen] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [showJsonOptions, setShowJsonOptions] = useState(false);
  const [sourceImageHeight, setSourceImageHeight] = useState(192);
  const [maleStyleSnippets, setMaleStyleSnippets] = useState([]);
  const [femaleStyleSnippets, setFemaleStyleSnippets] = useState([]);
  const [groupStyleSnippets, setGroupStyleSnippets] = useState([]);
  const [maleTextOnlyDirective, setMaleTextOnlyDirective] = useState("");
  const [femaleTextOnlyDirective, setFemaleTextOnlyDirective] = useState("");
  const [groupTextOnlyDirective, setGroupTextOnlyDirective] = useState("");
  const [activeStyleBuilderTarget, setActiveStyleBuilderTarget] =
    useState("male");
  const [globalCompositionSnippet, setGlobalCompositionSnippet] = useState({
    id: null,
    image: { file: null, preview: null, base64: null },
    instruction: null,
    baseInstructionLength: null,
    originalInstruction: null
  });
  const [activeTab, setActiveTab] = useState("identity");
  const [is4K, setIs4K] = useState(false);
  const [apikey, setApikey] = useState(null);
  const [imgCredits, setimgCredits] = useState(0);
  const [buyFlg, setBuyFlg] = useState(false);

  const [chooseFiles, setChooseFiles] = useState(false);
  const [imageFileList, setImageFileList] = useState({});
  const [isEnhanceModal, setEnhanceModal] = useState(false);

  const handleBuyFlg = () => {
    let isConfirmed;
    if (hasGroupImages || hasBgRef || hasReference) {
      isConfirmed = confirm(
        `Any uploaded images & or propmpts will be lost!!! \n\n Continue?`
      );
      if (isConfirmed) {
        setBuyFlg(true);
      } else return;
    } else setBuyFlg(true);
  };

  function showSpinner() {
    document.getElementById("loading-overlay").classList.remove("hidden");
  }

  function hideSpinner() {
    document.getElementById("loading-overlay").classList.add("hidden");
  }

  let countryCode = getCookie("countryCode");
  // countryCode = "US";

  async function getimgcreditsfromDB() {
    let imgcredits_uri = ENDPOINTS.imgcredits.index.uri;
    let noRecords;

    imgcredits_uri = imgcredits_uri + "?countryCode=" + countryCode;

    (async () => {
      noRecords = await fetch(imgcredits_uri, {
        method: "GET",
        headers: { "content-type": "application/json" }
      })
        .then((response) => response.json())
        .then((data) => {
          // setApikey(data.apikey);
          setimgCredits(data.imgcredits);
        });
    })();
  }

  getimgcreditsfromDB();

  const setimgcreditsfromDB = (imgcredits) => {
    let imgcredits_uri = ENDPOINTS.imgcredits.index.uri;
    let noRecords;

    imgcredits_uri = imgcredits_uri + "?imgcredits=" + imgcredits;

    (async () => {
      noRecords = await fetch(imgcredits_uri, {
        method: "GET",
        headers: { "content-type": "application/json" }
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.errors) {
            alert(data.errors);
            return;
          }
          setimgCredits(data.imgcredits);
        });
    })();
  };

  const [groupMembers, setGroupMembers] = useState(
    Array.from({ length: 5 }, (_, i) => ({
      id: `member-${i}`,
      image: null,
      label: "",
      expression: "original",
      posture: "original",
      hairStyle: "keep",
      facialHair: "default",
      eyewear: "none"
    }))
  );

  const [bgType, setBgType] = useState("none");
  const [bgColor, setBgColor] = useState("#5d4037"); // Default to a classic retro brown
  const [bgBlur, setBgBlur] = useState(false);
  const [bgBlurDepth, setBgBlurDepth] = useState(50);
  const [bgNoise, setBgNoise] = useState(false);
  const [bgNoiseMonochromatic, setBgNoiseMonochromatic] = useState(true);
  const [noiseLevel, setNoiseLevel] = useState(30);
  const [gradientStops, setGradientStops] = useState([
    { id: "1", color: "#1e293b", offset: 0 },
    { id: "2", color: "#475569", offset: 100 }
  ]);
  const [gradientStyle, setGradientStyle] = useState("linear");
  const [gradientAngle, setGradientAngle] = useState(135);

  const toggleChooseFiles = () => {
    setChooseFiles(!chooseFiles);
  };

  const showModal = () => {
    setEnhanceModal(!isEnhanceModal);
  };

  const graduationStyles = [
    "High School",
    "Bachelors",
    "Masters",
    "Doctoral",
    "Faculty",
    "Kindergarten",
    "Mexican"
  ];

  const graduationProps = [
    { value: "none", label: "None" },
    { value: "scroll", label: "Hold Scroll" },
    { value: "holdHat", label: "Hold Hat" },
    { value: "touchHat", label: "Touch Hat" },
    { value: "touchTassel", label: "Touch Tassel" }
  ];

  const [options, setOptions] = useState(DEFAULT_OPTIONS);

  const hasReference =
    !!mainImage || !!maleRef || !!femaleRef || !!groupStyleRef;
  const hasGroupImages = groupMembers.some((m) => m.image !== null);
  const hasBgRef = !!bgRef;
  const isBgSettingsDisabled = hasBgRef;

  const hasBackgroundReferenceInText = useMemo(() => {
    const text = (
      (options.textOnlyDirective || "") +
      " " +
      (maleTextOnlyDirective || "") +
      " " +
      (femaleTextOnlyDirective || "") +
      " " +
      (groupTextOnlyDirective || "")
    ).toLowerCase();
    const keywords = [
      "background",
      "backdrop",
      "setting",
      "environment",
      "scenery",
      "location",
      "beach",
      "studio",
      "outdoor",
      "indoor",
      "garden",
      "street",
      "city",
      "mountain",
      "forest",
      "park",
      "interior",
      "exterior"
    ];
    return keywords.some((kw) => text.includes(kw));
  }, [
    options.textOnlyDirective,
    maleTextOnlyDirective,
    femaleTextOnlyDirective,
    groupTextOnlyDirective
  ]);

  const prevHasBgRef = useRef(hasBgRef);
  const prevHasTextRef = useRef(hasBackgroundReferenceInText);

  useEffect(() => {
    // 1. If image is uploaded, force reference mode
    if (hasBgRef) {
      if (bgType !== "reference") setBgType("reference");
    }
    // 2. If image was JUST removed, revert to none
    else if (!hasBgRef && prevHasBgRef.current) {
      setBgType("none");
    }
    // 3. If text reference JUST appeared and we are in 'none', suggest reference
    else if (
      hasBackgroundReferenceInText &&
      !prevHasTextRef.current &&
      bgType === "none"
    ) {
      setBgType("reference");
    }
    // 4. If text reference JUST disappeared and we are in 'reference', revert to none
    else if (
      !hasBackgroundReferenceInText &&
      prevHasTextRef.current &&
      bgType === "reference"
    ) {
      setBgType("none");
    }

    prevHasBgRef.current = hasBgRef;
    prevHasTextRef.current = hasBackgroundReferenceInText;
  }, [hasBgRef, hasBackgroundReferenceInText, bgType]);

  // Synchronize single source image removal with male/female style reference removal
  // useEffect(() => {
  //   if (!mainImage) {
  //     if (maleRef !== null) setMaleRef(null);
  //     if (femaleRef !== null) setFemaleRef(null);
  //   }
  // }, [mainImage, maleRef, femaleRef]);

  // Synchronize group source image removal with group style reference removal & settings reset
  useEffect(() => {
    if (!hasGroupImages) {
      // 1. Remove group style reference
      if (groupStyleRef !== null) {
        setGroupStyleRef(null);
      }

      // 2. Reset all settings for group images in Group studio (identifier, expression, posture, hairStyle, etc.)
      const hasModifiedSettings = groupMembers.some(
        (m) =>
          m.label !== "" ||
          m.expression !== "original" ||
          m.posture !== "original" ||
          m.hairStyle !== "keep" ||
          m.facialHair !== "default" ||
          m.eyewear !== "none" ||
          (m.attire && m.attire !== "") ||
          m.gender !== "unknown"
      );

      if (hasModifiedSettings) {
        setGroupMembers(
          Array.from({ length: 5 }, (_, i) => ({
            id: `member-${i}`,
            image: null,
            label: "",
            expression: "original",
            posture: "original",
            hairStyle: "keep",
            facialHair: "default",
            eyewear: "none",
            attire: "",
            gender: "unknown"
          }))
        );
      }
    }
  }, [hasGroupImages, groupMembers, groupStyleRef]);

  const prevHasGroupImages = useRef(hasGroupImages);
  useEffect(() => {
    if (hasGroupImages !== prevHasGroupImages.current) {
      if (hasGroupImages) {
        handleOptionChange("aspectRatio", "9:16");
      } else {
        handleOptionChange("aspectRatio", "3:4");
      }
      prevHasGroupImages.current = hasGroupImages;
    }
  }, [hasGroupImages]);

  // Automatically suggest 'clone' posture when a group style reference is added
  useEffect(() => {
    if (groupStyleRef) {
      setGroupMembers((prev) =>
        prev.map((m) =>
          // (m.image && m.posture === 'original') ? { ...m, posture: 'clone' } : m
          ({ ...m, posture: "clone" })
        )
      );
      // Automatically switch background type to 'reference' when a group style is added
      setBgType("reference");
    }
  }, [groupStyleRef]);

  const getAiStudio = () => window.aistudio;

  const generateRandomColor = () => {
    return (
      "#" +
      Math.floor(Math.random() * 16777215)
        .toString(16)
        .padStart(6, "0")
    );
  };

  const handleRandomizeGradient = () => {
    const stopCount = 2 + Math.floor(Math.random() * 2);
    const newStops = [];
    for (let i = 0; i < stopCount; i++) {
      newStops.push({
        id: Math.random().toString(36).substr(2, 9),
        color: generateRandomColor(),
        offset: Math.round((i / (stopCount - 1)) * 100)
      });
    }
    setGradientStops(newStops);
    setGradientAngle(Math.floor(Math.random() * 360));
  };

  /**
   * Reverses the gradient by flipping the color sequence.
   * To achieve a visual color reversal, we flip the offsets and sort them.
   * For linear gradients, we DO NOT flip the angle because flipping the offsets
   * already swaps the colors visually along the existing direction line.
   * Doing both cancels out the effect.
   */
  const handleReverseGradient = () => {
    setGradientStops((prev) => {
      return [...prev]
        .map((stop) => ({
          ...stop,
          offset: 100 - stop.offset
        }))
        .sort((a, b) => a.offset - b.offset);
    });
  };

  const addGradientStop = () => {
    if (gradientStops.length >= 5) return;
    const newStop = {
      id: Math.random().toString(36).substr(2, 9),
      color: generateRandomColor(),
      offset: 50
    };
    setGradientStops(
      [...gradientStops, newStop].sort((a, b) => a.offset - b.offset)
    );
  };

  const removeGradientStop = (id) => {
    if (gradientStops.length <= 2) return;
    setGradientStops(gradientStops.filter((s) => s.id !== id));
  };

  const updateGradientStop = (id, updates) => {
    setGradientStops(
      gradientStops.map((s) => (s.id === id ? { ...s, ...updates } : s))
    );
  };

  const handleUpdateGroupMember = (index, updates) => {
    let finalUpdates = { ...updates };
    const currentMember = groupMembers[index];

    // Automatically assign 'sub-X' if image is newly uploaded and the current label is empty/blank
    if (
      updates.image &&
      (!currentMember.label || currentMember.label.trim() === "")
    ) {
      finalUpdates.label = `sub-${index + 1}`;
    }

    setGroupMembers((prev) =>
      prev.map((m, i) => (i === index ? { ...m, ...finalUpdates } : m))
    );
  };

  const handleUploadMemberImage = async (index, image) => {
    await validateAndSetImage(
      image,
      (img) => handleUpdateGroupMember(index, { image: img }),
      `Member ${index + 1}`
    );
  };

  // useEffect(() => {
  //   const checkKey = async () => {
  //     try {
  //       const studio = getAiStudio();
  //       if (studio && typeof studio.hasSelectedApiKey === "function") {
  //         const selected = await studio.hasSelectedApiKey();
  //         setHasKey(selected);
  //       }
  //     } catch (e) {
  //       console.error(e);
  //     }
  //   };
  //   checkKey();
  // }, []);

  useEffect(() => {
    let interval;
    if (isGenerating) {
      const msgs = hasGroupImages
        ? [
            "Detecting persons and or pets...",
            "Analyzing genders & features...",
            "Matching attire references...",
            "Rendering lighting...",
            "Synthesizing high-end group portrait...",
            "Still working... high quality takes time.",
            "Refining skin textures...",
            "Almost there... Gemini 3 Pro is finishing up."
          ]
        : [
            "Detecting person...",
            "Analyzing gender & features...",
            "Matching attire reference...",
            "Rendering lighting...",
            "Synthesizing high-end portrait...",
            "Still working... high quality takes time.",
            "Refining skin textures...",
            "Almost there... Gemini 3 Pro is finishing up."
          ];
      let idx = 0;
      setLoadingMessage(msgs[0]);
      interval = window.setInterval(() => {
        idx = idx + 1;
        if (idx >= msgs.length) {
          // Stay on last message but add a "Patience is key" suffix if it loops or stays
          setLoadingMessage(msgs[msgs.length - 1] + " (Still processing...)");
        } else {
          setLoadingMessage(msgs[idx]);
        }
      }, 8000); // Slower interval for realistic expectations
    }
    return () => clearInterval(interval);
  }, [isGenerating]);

  useEffect(() => {
    let interval;
    if (!isSafe) {
      const msgs = [
        "Detecting person...",
        "Analyzing gender & features...",
        "Checking attire reference...",
        "Validating safety checks..."
      ];
      let idx = 0;
      setLoadingMessage(msgs[0]);
      interval = window.setInterval(() => {
        idx = (idx + 1) % msgs.length;
        setLoadingMessage(msgs[idx]);
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [!isSafe]);

  const handleClose = () => {
    window.location.href = "/";
  };

  const handleSelectKey = async () => {
    try {
      const studio = getAiStudio();
      if (studio) {
        await studio.openSelectKey();
        setHasKey(true);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleOptionChange = (key, value) => {
    setOptions((prev) => {
      const newOptions = { ...prev, [key]: value };
      return newOptions;
    });
  };

  const handle4K = (value) => {
    if (groupMembers.filter((m) => m.image !== null).length >= 2) {
      if (countryCode !== "IN") {
        if (imgCredits < 4) {
          alert("Insufficient Image Credits!");
          return;
        }
      } else {
        if (imgCredits < 3) {
          alert("Insufficient Image Credits!");
          return;
        }
      }
    } else {
      if (countryCode !== "IN") {
        if (imgCredits < 3) {
          alert("Insufficient Image Credits!");
          return;
        }
      } else {
        if (imgCredits < 2) {
          alert("Insufficient Image Credits!");
          return;
        }
      }
    }

    setIs4K(value);
  };

  const setAttireMode = (mode) => {
    setOptions((prev) => ({
      ...prev,
      attireMode: mode,
      isGraduation: mode === "graduation",
      keepDress: mode === "keepOriginal",
      posture: mode === "professional" ? "professional" : prev.posture
    }));
  };

  const validateAndSetImage = async (apikey, img, setter, label) => {
    setError(null);
    setIsSafe(false);
    try {
      showSpinner();
      const safety = await validateImageSafety(apikey, img);
      hideSpinner();
      // alert("MODEL not available. Try Again.");
      if (safety.safe && safety.reason === "quota exceeded") {
        setter(null);
        hideSpinner();
        // setError(`${label} ai model: Unavailable. Try later`);
        alert(`ai model: Unavailable!!!. Try later.`);
      }
      if (!safety.safe) {
        setter(null);
        hideSpinner();
        setIsSafe(true);
        setError(`${label} rejected: ${safety.reason}`);
        alert(`${label} rejected: ${safety.reason}`);
      } else {
        setter(img);
        hideSpinner();
        setIsSafe(true);
      }
    } catch (err) {
      console.error(err);
      // Fallback: if safety check fails due to network/API error, we still set the image
      // but the generation step will re-validate anyway.
      setter(img);
      hideSpinner();
      setIsSafe(true);
    }
  };

  const currentConfig = {
    background: {
      type: bgType,
      color: bgColor,
      gradientStops,
      gradientStyle,
      gradientAngle,
      blur: bgBlur,
      blurDepth: bgBlurDepth,
      noise: bgNoise,
      noiseLevel: noiseLevel,
      noiseMonochromatic: bgNoiseMonochromatic
    },
    options,
    references: {
      hasMaleRef: !!maleRef,
      hasFemaleRef: !!femaleRef,
      hasGroupStyleRef: !!groupStyleRef,
      hasBgRef: !!bgRef
    },
    groupMembers: groupMembers.filter((m) => m.image !== null)
  };

  const handleBatchGenerate = async () => {
    if (imgCredits < 1) {
      alert("You don't have sufficient Image Credits!");
      return;
    }

    const isConfirmed = confirm(
      `Have you checked all settings?\nHave you checked all Prompts if any?\n\n${
        Object.keys(imageFileList).length
      } Image Credits will be debited.\n\nOnce Batch process initiated, it cannot be cancelled!!\n\nContinue?`
    );
    if (isConfirmed) {
      alert(
        "Thanks for confirming. Click 'OK' to Initiate Batch Image generation..."
      );
    } else {
      alert("Batch Image Generation Canceled");
      return;
    }
    if (maleRef) {
      Object.keys(maleRef).map((key) => {
        // console.log(`Key => ${key}`);
      });
      // return;
    }

    let fileNamesArray = Object.keys(imageFileList);
    // console.log(`fileNamesArray => ${fileNamesArray}`);
    // console.log(`configJson => ${JSON.stringify(currentConfig, null, 2)}`);
    // return;

    let configJson = JSON.stringify(currentConfig, null, 2);
    let formData = new FormData();
    if (maleRef) formData.append("maleRef", maleRef.file);
    if (femaleRef) formData.append("femaleRef", femaleRef.file);
    if (bgRef) formData.append("bgRef", bgRef.file);
    formData.append("fileNamesArray", fileNamesArray);
    formData.append("configJson", configJson);
    formData.append("batchCount", Object.keys(imageFileList).length);
    formData.append("maleStyleSnippets", JSON.stringify(maleStyleSnippets));
    formData.append(
      "maleTextOnlyDirective",
      JSON.stringify(maleTextOnlyDirective)
    );
    formData.append("femaleStyleSnippets", JSON.stringify(femaleStyleSnippets));
    formData.append(
      "femaleTextOnlyDirective",
      JSON.stringify(femaleTextOnlyDirective)
    );
    formData.append("countryCode", countryCode);

    // console.log(`styleSnippets => ${JSON.stringify(styleSnippets)}`);

    let url = "/api/batch_enhance";
    let ajaxCall = fetch(url, {
      method: "POST",
      body: formData
    });
    return ajaxCall
      .then((response) => response.json())
      .then((response) => {
        // console.log(`response.data => ${response.data}`);
        // console.log(`response => ${JSON.stringify(response)}`);
        if (response.status === 205)
          setimgCredits(imgCredits - Object.keys(imageFileList).length);
        alert(response.data);
        window.location.href = "/products";
      });
  };

  const handleGenerate = async () => {
    if (!mainImage) {
      setError("Upload your photo first.");
      alert("Upload your photo first.");
      return;
    }

    let noOfImgCredits = 1;

    if (imgCredits < noOfImgCredits) {
      alert("You don't have sufficient Image Credits!");
      return;
    }

    const isConfirmed = confirm(
      `Have you checked all settings?\nHave you checked all Prompts if any?\n\n${noOfImgCredits} Image Credits will be debited.\n${
        is4K ? " (1 Image Credit added for 4K.)\n" : ""
      }\nWarning: \n\nMake sure you have stable internet connection.\nMake sure you do not close this window or refresh this page until image is generated. Doing so will make you not to receive the generated image you paid for.\n Download the image IMMEDIATELY.\n\nAs we do not store any of your images, make sure not to close and download image immediately.\n\nNo Refunds once initiated!\n\nContinue?`
    );
    if (isConfirmed) {
      setimgcreditsfromDB(noOfImgCredits);
      alert("Thanks for confirming. Click 'OK' to start Image generation...");
    } else {
      alert("Image Generation Canceled");
      return;
    }
    // return;

    if (mobile) {
      setActiveTab("result");
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    setIsGenerating(true);
    setError(null);
    setResult(null);
    setLoadingMessage("Screening images for safety...");

    try {
      // Final Safety Validation for all images before generation
      const imagesToValidate = [
        { img: mainImage, label: "Identity Photo" },
        { img: maleRef, label: "Male Reference" },
        { img: femaleRef, label: "Female Reference" },
        { img: groupStyleRef, label: "Group Style Reference" },
        { img: bgRef, label: "Background Reference" }
      ].filter((item) => item.img !== null);

      for (const item of imagesToValidate) {
        if (item.img) {
          const safety = await validateImageSafety(apikey, item.img);
          if (safety.safe && safety.reason === "quota exceeded") {
            setimgcreditsfromDB(-1 * noOfImgCredits);
            setIsGenerating(false);
            setter(null);
            setError(`${label} ai model: Unavailable. Try later`);
            alert(`${label} ai model: Unavailable. Try later`);
            hideSpinner();
            return;
          }
          if (!safety.safe) {
            setimgcreditsfromDB(-1 * noOfImgCredits);
            setIsGenerating(false);
            setError(`${item.label} rejected: ${safety.reason}`);
            alert(`${item.label} rejected: ${safety.reason}`);
            return;
          }
        }
      }

      setLoadingMessage("Checking image content...");
      const count = await countPeople(apikey, mainImage);
      if (count === -1 || count === -2) {
        setIsGenerating(false);
        setimgcreditsfromDB(-1 * noOfImgCredits);
        alert("MODEL not available. Try Again.");
        hideSpinner();
        return;
      }

      if (count > 1) {
        setimgcreditsfromDB(-1 * noOfImgCredits);
        setIsGenerating(false);
        setError(
          "Multiple people detected. Please upload an image containing ONLY one person."
        );
        alert(
          "Multiple people detected. Please upload an image containing ONLY one person."
        );
        return;
      }
      if (count === 0) {
        setimgcreditsfromDB(-1 * noOfImgCredits);
        setIsGenerating(false);
        setError(
          "No people detected. Please upload a clear photo of a person."
        );
        alert("No people detected. Please upload a clear photo of a person.");
        return;
      }

      setLoadingMessage("Detecting gender...");
      const gender = await detectGender(apikey, mainImage);

      if (gender === "NA") {
        setIsGenerating(false);
        setimgcreditsfromDB(-1 * noOfImgCredits);
        alert("MODEL not available. Try Again.");
        hideSpinner();
        return;
      }

      if (gender === "unknown") {
        setIsGenerating(false);
        setimgcreditsfromDB(-1 * noOfImgCredits);
        hideSpinner();
        return;
      }

      setLoadingMessage("Generating professional portrait (expect 60-90s)...");

      const activeSnippets =
        gender === "male" ? maleStyleSnippets : femaleStyleSnippets;
      const activeTextOnlyDirective =
        gender === "male" ? maleTextOnlyDirective : femaleTextOnlyDirective;
      const hasPoseInActiveSnippets = activeSnippets.some(
        (s) => classifySnippetInstruction(s.instruction || "").hasPose
      );

      const response = await generateProfessionalHeadshot(
        apikey,
        is4K,
        mainImage,
        currentConfig.background,
        {
          ...options,
          posture: hasPoseInActiveSnippets ? "clone" : options.posture,
          textOnlyDirective: activeTextOnlyDirective
        },
        gender,
        maleRef || undefined,
        femaleRef || undefined,
        bgRef || undefined,
        activeSnippets
      );
      setResult({
        imageUrl: response.imageUrl,
        usage: response.usage,
        timestamp: Date.now()
      });
      hideSpinner();
      setOptions((prev) => ({
        ...DEFAULT_OPTIONS,
        posture: hasPoseInActiveSnippets ? "clone" : DEFAULT_OPTIONS.posture,
        textOnlyDirective: ""
      }));
    } catch (err) {
      if (err.message === "API_KEY_RESET_REQUIRED") setHasKey(false);
      setError(
        err.message || "An unexpected error occurred during generation."
      );
      setimgcreditsfromDB(-1 * noOfImgCredits);
      alert(err.message || "An unexpected error occurred during generation.");
      hideSpinner();
    } finally {
      setIsGenerating(false);
      hideSpinner();
    }
  };

  const handleGenerateGroup = async () => {
    const activeMembers = groupMembers.filter((m) => m.image !== null);
    if (activeMembers.length < 2) {
      setError("At least 2 group members are required.");
      alert("At least 2 group members are required.");
      return;
    }

    let noOfImgCredits = 0;
    if (countryCode !== "IN") {
      if (is4K) {
        noOfImgCredits = 4;
      } else {
        noOfImgCredits = 3;
      }
    } else {
      if (is4K) {
        noOfImgCredits = 3;
      } else {
        noOfImgCredits = 2;
      }
    }

    if (imgCredits < noOfImgCredits) {
      alert("You don't have sufficient Image Credits!");
      return;
    }

    // const isConfirmed = confirm(
    //   `Have you checked all settings?\nHave you checked all Prompts if any?\n\n${noOfImgCredits} Image Credits will be debited.\n${
    //     is4K ? " (1 Image Credit added for 4K.)\n" : ""
    //   }\nNo Refunds once initiated!\n\n Continue?`
    // );
    const isConfirmed = confirm(
      `Have you checked all settings?\nHave you checked all Prompts if any?\n\n${noOfImgCredits} Image Credits will be debited.\n${
        is4K ? " (1 Image Credit added for 4K.)\n" : ""
      }\nWarning: \n\nMake sure you have stable internet connection.\nMake sure you do not close this window or refresh this page until image is generated. Doing so will make you not to receive the generated image you paid for.\n Download the image IMMEDIATELY.\n\nAs we do not store any of your images, make sure not to close and download image immediately.\n\nNo Refunds once initiated!\n\nContinue?`
    );
    if (isConfirmed) {
      setimgcreditsfromDB(noOfImgCredits);
      alert("Thanks for confirming. Click 'OK' to start Image generation...");
    } else {
      alert("Image Generation Canceled");
      return;
    }
    // return;

    if (mobile) {
      setActiveTab("result");
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    setIsGenerating(true);
    setError(null);
    setResult(null);
    setLoadingMessage("Screening identities for safety...");

    try {
      for (const member of activeMembers) {
        const safety = await validateImageSafety(apikey, member.image);

        if (safety.safe && safety.reason === "quota exceeded") {
          setimgcreditsfromDB(-1 * noOfImgCredits);
          setIsGenerating(false);
          setter(null);
          setError(`${label} ai model: Unavailable. Try later`);
          alert(`${label} ai model: Unavailable. Try later`);
          hideSpinner();
          return;
        }
        if (!safety.safe) {
          setimgcreditsfromDB(-1 * noOfImgCredits);
          setIsGenerating(false);
          setError(
            `Member "${member.label || "Subject"}" rejected: ${safety.reason}`
          );
          alert(
            `Member "${member.label || "Subject"}" rejected: ${safety.reason}`
          );
          return;
        }
      }

      setLoadingMessage("Synthesizing group portrait...");
      const response = await generateGroupPortrait(
        apikey,
        is4K,
        activeMembers.map((m) => ({
          image: m.image,
          label: m.label,
          expression: m.expression,
          posture: m.posture,
          hairStyle: m.hairStyle,
          facialHair: m.facialHair,
          eyewear: m.eyewear
        })),
        currentConfig.background,
        { ...options, textOnlyDirective: groupTextOnlyDirective },
        groupStyleRef || undefined,
        bgRef || undefined,
        globalCompositionSnippet.instruction
          ? globalCompositionSnippet.instruction
          : undefined,
        groupStyleSnippets
      );
      hideSpinner();
      setResult({
        imageUrl: response.imageUrl,
        usage: response.usage,
        timestamp: Date.now()
      });
      setOptions((prev) => ({ ...DEFAULT_OPTIONS, textOnlyDirective: "" }));
    } catch (err) {
      setimgcreditsfromDB(-1 * noOfImgCredits);
      hideSpinner();
      if (err.message === "API_KEY_RESET_REQUIRED") setHasKey(false);
      setError(err.message || "An error occurred during group generation.");
      alert(err.message || "An error occurred during group generation.");
    } finally {
      setIsGenerating(false);
      hideSpinner();
    }
  };

  // const handleDownload = () => {
  //   if (!result) return;
  //   const link = document.createElement("a");
  //   link.href = result.imageUrl;
  //   link.download = `headshot-${Date.now()}.png`;
  //   link.click();
  // };

  const handleDownload = async () => {
    if (!result) return;
    try {
      const response = await fetch(result.imageUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `headshot-${Date.now()}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      // Fallback to direct link if fetch fails
      const link = document.createElement("a");
      link.href = result.imageUrl;
      link.target = "_blank";
      link.download = `headshot-${Date.now()}.png`;
      link.click();
    }
  };

  const previewGradient = () => {
    const sortedStops = [...gradientStops].sort((a, b) => a.offset - b.offset);
    const stopString = sortedStops
      .map((s) => `${s.color} ${s.offset}%`)
      .join(", ");
    return gradientStyle === "linear"
      ? `linear-gradient(${gradientAngle}deg, ${stopString})`
      : `radial-gradient(circle, ${stopString})`;
  };

  const renderBackgroundPreview = () => {
    if (bgType === "none") return null;

    let style = {};
    let content = null;

    if (bgType === "gradient") {
      style = { background: previewGradient() };
    } else if (bgType === "clean") {
      style = { backgroundColor: bgColor };
    } else if (bgType === "retro") {
      // Create a classic retro texture effect with CSS
      style = {
        backgroundColor: bgColor,
        backgroundImage: `radial-gradient(circle at center, transparent 0%, rgba(0,0,0,0.4) 100%), 
                          url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
        backgroundBlendMode: "overlay",
        backgroundSize: "cover",
        opacity: 0.9
      };
      content = (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <span className="text-[10px] font-bold text-white/20 uppercase tracking-[0.2em]">
            Retro Canvas Texture
          </span>
        </div>
      );
    } else if (bgType === "office") {
      style = {
        background:
          'linear-gradient(rgba(30,41,59,0.8), rgba(30,41,59,0.8)), url("https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=800") center/cover no-repeat'
      };
    }

    return (
      <React.Fragment>
        <label className="text-xs font-bold text-slate-500">
          Studio Backdrop Preview
        </label>
        {/* <div className="relative w-full  rounded-2xl overflow-hidden border border-slate-800 shadow-inner mb-6 animate-in fade-in zoom-in-95 duration-300" > */}
        <div
          className="relative w-full  rounded-2xl overflow-hidden border border-slate-800 shadow-inner mb-6 animate-in fade-in zoom-in-95 duration-300"
          style={{ height: "10rem" }}
        >
          <div
            className="absolute inset-0 transition-all duration-500"
            style={style}
          >
            {content}
          </div>
        </div>
      </React.Fragment>
    );
  };

  if (!hasKey) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-slate-950 text-white">
        <div className="max-w-md w-full glass p-8 rounded-3xl text-center">
          <h1 className="text-3xl font-bold mb-4">Professional Studio</h1>
          <p className="text-slate-400 mb-8 text-sm">
            Select an API key to start generating high-end headshots.
          </p>
          <button
            onClick={handleSelectKey}
            className="w-full bg-indigo-600 hover:bg-indigo-500 font-bold py-3 px-6 rounded-xl shadow-lg"
          >
            Select API Key
          </button>
        </div>
      </div>
    );
  }

  return (
    <React.Fragment>
      {/* {buyFlg && <FileManager flg={buyFlg} setBuyFlg={setBuyFlg} />} */}
      <div
        className="min-h-screen pb-32 bg-slate-950 text-slate-200"
        style={{ marginTop: mobile ? "70px" : "-18px" }}
      >
        <header className="glass sticky top-0 z-10 px-6 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-2">
            {/* <div className="w-8 h-8 bg-indigo-600 rounded-lg flex items-center justify-center text-white font-bold"> */}
            {/* P */}
            <div className="flex items-center justify-center  font-bold">
              <img height="35px" src={logo} />
            </div>
            <span className="font-bold text-amber-500 text-lg">
              ProHeadshot AI
            </span>
          </div>
          {/* <button
          onClick={handleSelectKey}
          className="text-xs px-3 py-1.5 bg-slate-800 rounded-full hover:bg-slate-700"
        >
          Change Key
        </button> */}
          <span>Image Credits Available: {imgCredits}</span>
          <button
            onClick={toggleChooseFiles}
            className="text-xs px-3 py-1.5 bg-slate-800 rounded-full hover:bg-slate-700"
          >
            Choose Images from Uploaded Files
          </button>

          <div style={{ display: "none" }}>
            {chooseFiles && (
              <FileManager
                setChooseFiles={setChooseFiles}
                fetchImageFileList={setImageFileList}
                flg={true}
              />
            )}
          </div>
          <button
            onClick={() => {
              // console.log(Object.keys(imageFileList).length);
              // Object.keys(imageFileList).map((file_path) => {
              //   console.log(file_path);
              // });
              if (Object.keys(imageFileList).length === 0) {
                alert("No files chosen!");
              } else showModal();
            }}
          >
            Show chosen files
          </button>
        </header>

        <main
          className="max-w-7xl mx-auto px-4 md:px-6 pt-6 md:pt-10 grid grid-cols-1 lg:grid-cols-12 gap-10"
          style={{ marginTop: "1%" }}
        >
          <div
            className={`lg:col-span-8 space-y-8 ${
              activeTab !== "result" ? "block" : "hidden lg:block"
            }`}
          >
            <section
              className={`space-y-4 ${
                activeTab === "identity" || !mobile
                  ? "block"
                  : "hidden lg:block"
              }`}
            >
              {!hasGroupImages ? (
                <React.Fragment>
                  <ImageUploader
                    label="Identity Photo"
                    description="Clear face photo (Single person ONLY)"
                    image={mainImage}
                    onUpload={(img) => {
                      validateAndSetImage(
                        apikey,
                        img,
                        setMainImage,
                        "Identity Photo"
                      );
                    }}
                    onClear={() => {
                      setMainImage(null);
                    }}
                    onError={setError}
                    required
                    height={sourceImageHeight}
                  />
                  <div className="flex flex-col items-center space-y-1 py-2">
                    <label className="text-[10px] font-bold text-slate-500 uppercase">
                      Zoom Image
                    </label>
                    <input
                      type="range"
                      min="150"
                      max="500"
                      value={sourceImageHeight}
                      onChange={(e) =>
                        setSourceImageHeight(parseInt(e.target.value))
                      }
                      // className="w-64 h-1 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-indigo-500"
                      className="h-1 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-indigo-500"
                      style={{ width: "175px" }}
                    />
                  </div>
                </React.Fragment>
              ) : (
                <div className="grid grid-cols-2 md:grid-cols-5 gap-4 animate-in fade-in slide-in-from-top-4 duration-500">
                  {groupMembers
                    .filter((m) => m.image !== null)
                    .map((member) => (
                      <div key={member.id} className="relative group">
                        <div className="aspect-[3/4] rounded-2xl overflow-hidden border border-indigo-500/30 bg-slate-900 shadow-lg">
                          <img
                            src={member.image.preview}
                            alt={member.label || "Member"}
                            className="w-full h-full object-cover"
                          />
                          <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-3">
                            <p
                              className="text-[10px] font-bold text-white uppercase truncate"
                              style={{ marginLeft: "20px" }}
                            >
                              {member.label || "Member"}
                            </p>
                          </div>
                        </div>
                        <button
                          onClick={() =>
                            handleUpdateGroupMember(
                              groupMembers.findIndex((m) => m.id === member.id),
                              { image: null }
                            )
                          }
                          className="absolute -top-2 -right-2 bg-rose-600 text-white rounded-full flex items-center justify-center shadow-lg group-hover:opacity-100 transition-opacity"
                          style={{ height: "20px", width: "20px" }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-3.5 w-3.5"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </button>
                      </div>
                    ))}
                </div>
              )}

              <p className="flex flex-col items-center space-y-2 py-2 text-[10px] text-amber-500 font-semibold mt-1 uppercase tracking-tight">
                Images will be rejected if decent images wearing decent attires
                are not provided.
              </p>
            </section>

            <section
              className={`space-y-6 ${
                activeTab === "style" || activeTab === "settings" || !mobile
                  ? "block"
                  : "hidden lg:block"
              }`}
            >
              <h2 className="text-lg font-bold flex items-center space-x-2">
                <span className="text-indigo-400">02</span>
                <span style={{ color: "white" }}>Refinement Controls</span>
              </h2>
              {/* <div className="glass p-4 md:p-6 rounded-3xl space-y-8"> */}
              <div className="glass md:p-6 rounded-3xl space-y-8">
                {/* GLOBAL STYLE & REFERENCES */}
                <div
                  className={`space-y-6 ${
                    activeTab === "style" || !mobile
                      ? "block"
                      : "hidden lg:block"
                  }`}
                >
                  <div className="flex items-center justify-between border-b border-indigo-500/20 pb-2">
                    <h4 className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest">
                      Style References
                    </h4>
                    <button
                      onClick={() => setIsStyleBuilderOpen(true)}
                      className="text-[10px] font-bold text-indigo-400 hover:text-indigo-300 hover:bg-indigo-500/10 uppercase tracking-widest px-3 py-1 rounded-full border border-indigo-500/20 transition-all active:scale-95 flex items-center space-x-1"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        // className="h-3 w-3"
                        style={{ height: "20px", width: "20px" }}
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379-1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span>Style Builder</span>
                    </button>
                  </div>
                  <p className="text-[10px] text-slate-500 italic">
                    Upload attire references. The engine detects gender and
                    prioritizes matching reference.
                  </p>
                  <div
                    className={`grid gap-4 ${
                      hasGroupImages
                        ? "grid-cols-1"
                        : "grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
                    }`}
                  >
                    {!hasGroupImages ? (
                      <React.Fragment>
                        <ImageUploader
                          label="Male Style Reference"
                          description="Auto-applied for Male subjects"
                          image={maleRef}
                          onUpload={(img) =>
                            validateAndSetImage(
                              apikey,
                              img,
                              setMaleRef,
                              "Male Reference"
                            )
                          }
                          onClear={() => setMaleRef(null)}
                          onError={setError}
                        />
                        <ImageUploader
                          label="Female Style Reference"
                          description="Auto-applied for Female subjects"
                          image={femaleRef}
                          onUpload={(img) =>
                            validateAndSetImage(
                              apikey,
                              img,
                              setFemaleRef,
                              "Female Reference"
                            )
                          }
                          onClear={() => setFemaleRef(null)}
                          onError={setError}
                        />
                      </React.Fragment>
                    ) : (
                      <ImageUploader
                        label="Group Style Reference"
                        description="Catalogue style for group portraits"
                        image={groupStyleRef}
                        isGrpPreview={true}
                        onUpload={(img) =>
                          validateAndSetImage(
                            apikey,
                            img,
                            setGroupStyleRef,
                            "Group Style Reference"
                          )
                        }
                        onClear={() => setGroupStyleRef(null)}
                        onError={setError}
                      />
                    )}
                  </div>
                  <p className="flex flex-col items-center space-y-2 py-2 text-[10px] text-amber-500 font-semibold mt-1 uppercase tracking-tight">
                    Images will be rejected if decent images wearing decent
                    attires are not provided.
                  </p>
                </div>

                {/* ATTIRE MODE SELECTOR */}
                <div
                  className={`mt-8 pt-8 border-t border-slate-800/50 space-y-6 ${
                    activeTab === "style" || !mobile
                      ? "block"
                      : "hidden lg:block"
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider">
                      Attire Mode
                    </h3>
                    {hasReference && (
                      <span className="text-[10px] text-indigo-400 font-bold uppercase">
                        Reference Priority Enabled
                      </span>
                    )}
                  </div>

                  <div className="grid grid-cols-2 md:grid-cols-5 gap-2">
                    {[
                      { mode: "professional", label: "Professional" },
                      { mode: "graduation", label: "Graduation" },
                      { mode: "uniform", label: "Uniform" },
                      { mode: "casual", label: "Casual" },
                      { mode: "keepOriginal", label: "Keep Original" }
                    ].map(({ mode, label }) => (
                      <button
                        key={mode}
                        onClick={() => setAttireMode(mode)}
                        className={`py-3 px-2 rounded-xl text-xs font-bold border transition-all ${
                          options.attireMode === mode
                            ? "bg-indigo-600 border-indigo-500 text-white shadow-lg"
                            : "bg-slate-900 border-slate-800 text-slate-500 hover:bg-slate-800"
                        }`}
                      >
                        {label.toUpperCase()}
                      </button>
                    ))}
                  </div>

                  {/* MODE SPECIFIC OPTIONS PANELS */}
                  <div className="mt-8 min-h-[100px]">
                    {/* PROFESSIONAL MODE */}
                    {options.attireMode === "professional" && (
                      <div className="space-y-8 animate-in fade-in slide-in-from-top-2 border-t border-slate-800/50 pt-8">
                        {/* <div className="bg-slate-900/40 p-6 rounded-3xl border border-slate-800 max-w-4xl mx-auto space-y-10"> */}
                        <div className="bg-slate-900/40 md:p-6 rounded-3xl border border-slate-800 max-w-4xl mx-auto space-y-10">
                          <div className="border-b border-slate-800 pb-4">
                            <h4 className="text-xs font-bold text-slate-400 uppercase tracking-widest">
                              Outerwear Customization
                            </h4>
                          </div>

                          {/* SUIT / BLAZER SECTION */}
                          <div className="space-y-8">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                              <div className="space-y-4">
                                <label className="text-xs font-bold text-slate-500 uppercase block tracking-widest">
                                  Attire Type
                                </label>
                                <div className="flex flex-col space-y-3">
                                  <div className="flex flex-wrap bg-slate-950 rounded-xl p-1 border border-slate-800 gap-1">
                                    <button
                                      onClick={() =>
                                        handleOptionChange("attireType", "suit")
                                      }
                                      className={`flex-1 min-w-[100px] py-2 rounded-lg text-[10px] font-bold transition-all ${
                                        options.attireType === "suit"
                                          ? "bg-indigo-600 text-white shadow-md"
                                          : "text-slate-500 hover:text-slate-300"
                                      }`}
                                    >
                                      BUSINESS SUIT
                                    </button>
                                    <button
                                      onClick={() =>
                                        handleOptionChange(
                                          "attireType",
                                          "blazer"
                                        )
                                      }
                                      className={`flex-1 min-w-[100px] py-2 rounded-lg text-[10px] font-bold transition-all ${
                                        options.attireType === "blazer"
                                          ? "bg-indigo-600 text-white shadow-md"
                                          : "text-slate-500 hover:text-slate-300"
                                      }`}
                                    >
                                      PROFESSIONAL BLAZER
                                    </button>
                                    <button
                                      onClick={() =>
                                        handleOptionChange(
                                          "attireType",
                                          "three-piece"
                                        )
                                      }
                                      className={`flex-1 min-w-[100px] py-2 rounded-lg text-[10px] font-bold transition-all ${
                                        options.attireType === "three-piece"
                                          ? "bg-indigo-600 text-white shadow-md"
                                          : "text-slate-500 hover:text-slate-300"
                                      }`}
                                    >
                                      3 PIECE SUIT
                                    </button>
                                    <button
                                      onClick={() =>
                                        handleOptionChange(
                                          "attireType",
                                          "tuxedo"
                                        )
                                      }
                                      className={`flex-1 min-w-[100px] py-2 rounded-lg text-[10px] font-bold transition-all ${
                                        options.attireType === "tuxedo"
                                          ? "bg-indigo-600 text-white shadow-md"
                                          : "text-slate-500 hover:text-slate-300"
                                      }`}
                                    >
                                      TUXEDO
                                    </button>
                                  </div>

                                  {options.attireType === "blazer" && (
                                    <div className="flex bg-slate-950/50 rounded-lg p-1 border border-slate-800/50 animate-in fade-in slide-in-from-top-1">
                                      <button
                                        onClick={() =>
                                          handleOptionChange(
                                            "blazerStyle",
                                            "standard"
                                          )
                                        }
                                        // className={`flex-1 py-1.5 rounded text-[9px] font-bold transition-all ${
                                        className={`flex-1 text-[9px] font-bold transition-all ${
                                          options.blazerStyle === "standard"
                                            ? "bg-indigo-600 text-white"
                                            : "text-slate-500 hover:text-slate-400"
                                        }`}
                                        style={{ height: "25px" }}
                                      >
                                        STANDARD
                                      </button>
                                      <button
                                        onClick={() =>
                                          handleOptionChange(
                                            "blazerStyle",
                                            "english"
                                          )
                                        }
                                        // className={`flex-1 py-1.5 rounded text-[9px] font-bold transition-all ${
                                        className={`flex-1 text-[9px] font-bold transition-all ${
                                          options.blazerStyle === "english"
                                            ? "bg-indigo-600 text-white"
                                            : "text-slate-500 hover:text-slate-400"
                                        }`}
                                        style={{ height: "25px" }}
                                      >
                                        ENGLISH
                                      </button>
                                    </div>
                                  )}

                                  {options.attireType === "three-piece" && (
                                    <div className="space-y-3 p-3 bg-slate-900/50 rounded-xl border border-slate-800 animate-in fade-in slide-in-from-top-1">
                                      <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest block">
                                        Vest Color
                                      </label>
                                      <div className="flex items-center space-x-3">
                                        <input
                                          type="color"
                                          value={options.vestColor}
                                          onChange={(e) =>
                                            handleOptionChange(
                                              "vestColor",
                                              e.target.value
                                            )
                                          }
                                          className="w-8 md:h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                                        />
                                        <div
                                          className="flex-1 md:h-8 rounded-lg border border-slate-700 flex items-center px-3 bg-slate-950 font-mono text-[10px] uppercase"
                                          style={{ color: "white" }}
                                        >
                                          {options.vestColor}
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  {options.attireType === "tuxedo" && (
                                    // <div className="space-y-4 p-3 bg-slate-900/50 rounded-xl border border-slate-800 animate-in fade-in slide-in-from-top-1">
                                    <div
                                      className="space-y-4 bg-slate-900/50 rounded-xl border border-slate-800 animate-in fade-in slide-in-from-top-1"
                                      style={{ padding: "12px" }}
                                    >
                                      <div className="space-y-2">
                                        <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest block">
                                          Lapel Type
                                        </label>
                                        <div className="flex bg-slate-950 rounded-lg p-1 border border-slate-800">
                                          {["notch", "peak", "shawl"].map(
                                            (l) => (
                                              <button
                                                key={l}
                                                onClick={() =>
                                                  handleOptionChange(
                                                    "lapelType",
                                                    l
                                                  )
                                                }
                                                // className={`flex-1 py-1.5 rounded text-[9px] font-bold transition-all ${
                                                className={`flex-1 text-[9px] font-bold transition-all ${
                                                  options.lapelType === l
                                                    ? "bg-indigo-600 text-white"
                                                    : "text-slate-500 hover:text-slate-400"
                                                }`}
                                                style={{ height: "20px" }}
                                              >
                                                {l.toUpperCase()}
                                              </button>
                                            )
                                          )}
                                        </div>
                                      </div>
                                      <div className="flex items-center justify-between">
                                        <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">
                                          Use Bow Tie
                                        </label>
                                        <button
                                          onClick={() =>
                                            handleOptionChange(
                                              "hasBowTie",
                                              !options.hasBowTie
                                            )
                                          }
                                          className={`md:w-10 md:h-5 rounded-full transition-all relative ${
                                            options.hasBowTie
                                              ? "bg-indigo-600"
                                              : "bg-slate-800"
                                          }`}
                                        >
                                          <div
                                            className={`absolute top-1 md:w-3 md:h-3 rounded-full bg-white transition-all ${
                                              options.hasBowTie
                                                ? "left-6"
                                                : "left-1"
                                            }`}
                                          />
                                        </button>
                                      </div>
                                      {options.hasBowTie && (
                                        <div className="space-y-4 animate-in fade-in">
                                          <div className="space-y-2">
                                            <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest block">
                                              Bow Tie Color
                                            </label>
                                            <div className="flex items-center space-x-3">
                                              <input
                                                type="color"
                                                value={options.bowTieColor}
                                                onChange={(e) =>
                                                  handleOptionChange(
                                                    "bowTieColor",
                                                    e.target.value
                                                  )
                                                }
                                                className="w-8 md:h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                                              />
                                              <div
                                                className="flex-1 md:h-8 rounded-lg border border-slate-700 flex items-center px-3 bg-slate-950 font-mono text-[10px] uppercase"
                                                style={{ color: "white" }}
                                              >
                                                {options.bowTieColor}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="space-y-2">
                                            <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest block">
                                              Cummerbund Color
                                            </label>
                                            <div className="flex items-center space-x-3">
                                              <input
                                                type="color"
                                                value={options.cummerbundColor}
                                                onChange={(e) =>
                                                  handleOptionChange(
                                                    "cummerbundColor",
                                                    e.target.value
                                                  )
                                                }
                                                className="w-8 md:h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                                              />
                                              <div
                                                className="flex-1 md:h-8 rounded-lg border border-slate-700 flex items-center px-3 bg-slate-950 font-mono text-[10px] uppercase"
                                                style={{ color: "white" }}
                                              >
                                                {options.cummerbundColor}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                  <div className="flex items-center justify-between pt-4 border-t border-slate-800">
                                    <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">
                                      Pocket Square
                                    </label>
                                    <button
                                      onClick={() =>
                                        handleOptionChange(
                                          "hasPocketSquare",
                                          !options.hasPocketSquare
                                        )
                                      }
                                      className={`md:w-10 md:h-5 rounded-full transition-all relative ${
                                        options.hasPocketSquare
                                          ? "bg-indigo-600"
                                          : "bg-slate-800"
                                      }`}
                                    >
                                      <div
                                        className={`absolute top-1 md:w-3 md:h-3 rounded-full bg-white transition-all ${
                                          options.hasPocketSquare
                                            ? "left-6"
                                            : "left-1"
                                        }`}
                                      />
                                    </button>
                                  </div>
                                  {options.hasPocketSquare && (
                                    <div className="space-y-2 animate-in fade-in">
                                      <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest block">
                                        Pocket Square Color
                                      </label>
                                      <div className="flex items-center space-x-3">
                                        <input
                                          type="color"
                                          value={options.pocketSquareColor}
                                          onChange={(e) =>
                                            handleOptionChange(
                                              "pocketSquareColor",
                                              e.target.value
                                            )
                                          }
                                          className="w-8 md:h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                                        />
                                        <div
                                          className="flex-1 md:h-8 rounded-lg border border-slate-700 flex items-center px-3 bg-slate-950 font-mono text-[10px] uppercase"
                                          style={{ color: "white" }}
                                        >
                                          {options.pocketSquareColor}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="space-y-4">
                                <label className="text-xs font-bold text-slate-500 block uppercase tracking-widest">
                                  Jacket Color
                                </label>
                                <div className="flex items-center space-x-3">
                                  <input
                                    type="color"
                                    value={options.attireColor}
                                    onChange={(e) =>
                                      handleOptionChange(
                                        "attireColor",
                                        e.target.value
                                      )
                                    }
                                    className="md:w-10 md:h-10 rounded-lg cursor-pointer bg-transparent border-none p-0"
                                  />
                                  <div
                                    className="flex-1 md:h-10 rounded-lg border border-slate-700 flex items-center px-3 bg-slate-900 font-mono text-xs uppercase"
                                    style={{ color: "white" }}
                                  >
                                    {options.attireColor}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="border-b border-slate-800 pb-4">
                            <h4 className="text-xs font-bold text-slate-400 uppercase tracking-widest">
                              Inner Layer Customization
                            </h4>
                            <p className="text-[10px] text-slate-500 mt-1">
                              Configure options for both Female (Blouse) and
                              Male (Shirt/Tie) subjects.
                            </p>
                          </div>

                          {/* INNER LAYERS: BLOUSE OR SHIRT/TIE */}
                          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
                            {/* <div className="space-y-6 p-6 bg-indigo-950/20 border border-indigo-500/20 rounded-3xl animate-in fade-in"> */}
                            <div className="space-y-6 md:p-6 bg-indigo-950/20 border border-indigo-500/20 rounded-3xl animate-in fade-in">
                              <div className="space-y-1">
                                <label className="text-xs font-bold text-indigo-400 uppercase tracking-widest block">
                                  Blouse (Female Subject)
                                </label>
                              </div>

                              <div className="space-y-4">
                                <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest block">
                                  Blouse Style
                                </label>
                                <div className="grid grid-cols-2 gap-2">
                                  {[
                                    {
                                      val: "buttoned-down",
                                      label: "Buttoned-down"
                                    },
                                    { val: "tie-neck", label: "Tie-neck" },
                                    { val: "peplum", label: "Peplum" },
                                    {
                                      val: "short-sleeve",
                                      label: "Short Sleeve"
                                    },
                                    { val: "sleeveless", label: "Sleeveless" },
                                    { val: "shirt-tie", label: "Shirt & Tie" }
                                  ].map((s) => (
                                    <button
                                      key={s.val}
                                      onClick={() =>
                                        handleOptionChange("blouseStyle", s.val)
                                      }
                                      className={`py-2 px-1 rounded-lg text-[9px] font-bold border transition-all ${
                                        options.blouseStyle === s.val
                                          ? "bg-indigo-600 border-indigo-500 text-white"
                                          : "bg-slate-900 border-slate-800 text-slate-500 hover:text-slate-300"
                                      }`}
                                    >
                                      {s.label.toUpperCase()}
                                    </button>
                                  ))}
                                </div>
                              </div>

                              {options.blouseStyle !== "shirt-tie" ? (
                                <div className="space-y-4 animate-in fade-in">
                                  <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest block">
                                    Blouse Color
                                  </label>
                                  <div className="flex items-center space-x-3">
                                    <input
                                      type="color"
                                      value={options.blouseColor}
                                      onChange={(e) =>
                                        handleOptionChange(
                                          "blouseColor",
                                          e.target.value
                                        )
                                      }
                                      className="md:w-10 md:h-10 rounded-lg cursor-pointer bg-transparent border-2 border-slate-800 p-1"
                                    />
                                    <div
                                      className="flex-1 md:h-10 rounded-lg border border-slate-800 flex items-center px-3 bg-slate-950 font-mono text-xs uppercase"
                                      style={{ color: "white" }}
                                    >
                                      {options.blouseColor}
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="space-y-6 pt-2 animate-in slide-in-from-top-2">
                                  <div className="grid grid-cols-2 gap-4">
                                    <div className="space-y-2">
                                      <label className="text-[9px] font-bold text-slate-500 uppercase block">
                                        Shirt Color
                                      </label>
                                      <input
                                        type="color"
                                        value={options.shirtColor}
                                        onChange={(e) =>
                                          handleOptionChange(
                                            "shirtColor",
                                            e.target.value
                                          )
                                        }
                                        className="w-full md:h-8 rounded-lg cursor-pointer bg-slate-900 border-slate-700"
                                      />
                                    </div>
                                    <div className="space-y-2">
                                      <label className="text-[9px] font-bold text-slate-500 uppercase block">
                                        Tie Color
                                      </label>
                                      <input
                                        type="color"
                                        value={options.tieColor}
                                        onChange={(e) =>
                                          handleOptionChange(
                                            "tieColor",
                                            e.target.value
                                          )
                                        }
                                        className="w-full md:h-8 rounded-lg cursor-pointer bg-slate-900 border-slate-700"
                                      />
                                    </div>
                                  </div>
                                  <div className="space-y-2">
                                    <label className="text-[9px] font-bold text-slate-500 uppercase block">
                                      Tie Pattern
                                    </label>
                                    <select
                                      value={options.tieStyle}
                                      onChange={(e) =>
                                        handleOptionChange(
                                          "tieStyle",
                                          e.target.value
                                        )
                                      }
                                      className="w-full md:h-8 bg-slate-900 border border-slate-800 rounded-lg px-2 text-[9px] outline-none font-bold uppercase"
                                    >
                                      {[
                                        "plain",
                                        "stripes",
                                        "dots",
                                        "stars",
                                        "textured",
                                        "random"
                                      ].map((s) => (
                                        <option key={s} value={s}>
                                          {s}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* SHIRT STYLE SECTION (MALE/GENERAL) */}
                            {/* <div className="space-y-6 p-6 bg-slate-950/40 rounded-3xl border border-slate-800 animate-in fade-in"> */}
                            <div className="space-y-6 md:p-6 bg-slate-950/40 rounded-3xl border border-slate-800 animate-in fade-in">
                              <label className="text-xs font-bold text-slate-400 uppercase block tracking-widest">
                                Shirt & Tie (Male Subject)
                              </label>

                              <div className="grid grid-cols-3 gap-3">
                                {[
                                  { value: "solid", label: "SOLID" },
                                  { value: "striped", label: "STRIPED" },
                                  { value: "gingham", label: "GINGHAM" }
                                ].map((s) => (
                                  <button
                                    key={s.value}
                                    onClick={() =>
                                      handleOptionChange("shirtStyle", s.value)
                                    }
                                    className={`py-2 rounded-lg text-[10px] font-bold border transition-all ${
                                      options.shirtStyle === s.value
                                        ? "bg-indigo-600 border-indigo-500 text-white shadow-lg"
                                        : "bg-slate-950 border-slate-800 text-slate-500 hover:bg-slate-800"
                                    }`}
                                  >
                                    {s.label}
                                  </button>
                                ))}
                              </div>

                              <div className="space-y-6">
                                {options.shirtStyle === "solid" && (
                                  <div className="space-y-4 animate-in fade-in">
                                    <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest block">
                                      Shirt Color
                                    </label>
                                    <div className="flex items-center space-x-4">
                                      <input
                                        type="color"
                                        value={options.shirtColor}
                                        onChange={(e) =>
                                          handleOptionChange(
                                            "shirtColor",
                                            e.target.value
                                          )
                                        }
                                        className="md:w-10 md:h-10 rounded-xl cursor-pointer bg-transparent border-2 border-slate-700 p-1"
                                      />
                                      <span className="text-xs font-mono text-indigo-400 uppercase font-bold">
                                        {options.shirtColor}
                                      </span>
                                    </div>
                                  </div>
                                )}

                                {options.shirtStyle === "striped" && (
                                  <div className="space-y-4 animate-in fade-in">
                                    <div className="grid grid-cols-2 gap-4">
                                      <div className="space-y-2">
                                        <label className="text-[9px] font-bold text-slate-500 uppercase block">
                                          Base Color
                                        </label>
                                        <input
                                          type="color"
                                          value={options.shirtColor}
                                          onChange={(e) =>
                                            handleOptionChange(
                                              "shirtColor",
                                              e.target.value
                                            )
                                          }
                                          className="w-full md:h-8 rounded-lg cursor-pointer bg-slate-900 border-slate-700"
                                        />
                                      </div>
                                      <div className="space-y-2">
                                        <label className="text-[9px] font-bold text-slate-500 uppercase block">
                                          Stripe Color
                                        </label>
                                        <input
                                          type="color"
                                          value={options.shirtStripeColor}
                                          onChange={(e) =>
                                            handleOptionChange(
                                              "shirtStripeColor",
                                              e.target.value
                                            )
                                          }
                                          className="w-full md:h-8 rounded-lg cursor-pointer bg-slate-900 border-slate-700"
                                        />
                                      </div>
                                    </div>
                                    <label className="text-[9px] font-bold text-slate-500 uppercase block">
                                      Stripe Thickness
                                    </label>
                                    <div className="flex bg-slate-950 rounded-lg p-1 border border-slate-800">
                                      {["thin", "medium", "thick"].map((w) => (
                                        <button
                                          key={w}
                                          onClick={() =>
                                            handleOptionChange(
                                              "shirtStripeWidth",
                                              w
                                            )
                                          }
                                          // className={`flex-1 py-1 rounded text-[8px] font-bold transition-all ${
                                          className={`flex-1 text-[9px] font-bold transition-all ${
                                            options.shirtStripeWidth === w
                                              ? // ? "bg-slate-700 text-white"
                                                // : "text-slate-500"
                                                "bg-indigo-600 text-white"
                                              : "text-slate-500 hover:text-slate-400"
                                          }`}
                                          style={{ height: "20px" }}
                                        >
                                          {w.toUpperCase()}
                                        </button>
                                      ))}
                                    </div>
                                  </div>
                                )}

                                {options.shirtStyle === "gingham" && (
                                  <div className="space-y-4 animate-in fade-in">
                                    <div className="grid grid-cols-2 gap-4">
                                      <div className="space-y-2">
                                        <label className="text-[9px] font-bold text-slate-500 uppercase block">
                                          Base Color
                                        </label>
                                        <input
                                          type="color"
                                          value={options.shirtColor}
                                          onChange={(e) =>
                                            handleOptionChange(
                                              "shirtColor",
                                              e.target.value
                                            )
                                          }
                                          className="w-full md:h-8 rounded-lg cursor-pointer bg-slate-900 border-slate-700"
                                        />
                                      </div>
                                      <div className="space-y-2">
                                        <label className="text-[9px] font-bold text-slate-500 uppercase block">
                                          Check Color
                                        </label>
                                        <input
                                          type="color"
                                          value={options.shirtCheckColor}
                                          onChange={(e) =>
                                            handleOptionChange(
                                              "shirtCheckColor",
                                              e.target.value
                                            )
                                          }
                                          className="w-full md:h-8 rounded-lg cursor-pointer bg-slate-900 border-slate-700"
                                        />
                                      </div>
                                    </div>
                                    <label className="text-[9px] font-bold text-slate-500 uppercase block">
                                      Checks Size
                                    </label>
                                    <div className="flex bg-slate-950 rounded-lg p-1 border border-slate-800">
                                      {["small", "medium", "large"].map((s) => (
                                        <button
                                          key={s}
                                          onClick={() =>
                                            handleOptionChange(
                                              "shirtCheckSize",
                                              s
                                            )
                                          }
                                          // className={`flex-1 py-1 rounded text-[8px] font-bold transition-all ${
                                          className={`flex-1 text-[9px] font-bold transition-all ${
                                            options.shirtCheckSize === s
                                              ? // ? "bg-slate-700 text-white"
                                                // : "text-slate-500"
                                                "bg-indigo-600 text-white"
                                              : "text-slate-500 hover:text-slate-400"
                                          }`}
                                          style={{ height: "20px" }}
                                        >
                                          {s.toUpperCase()}
                                        </button>
                                      ))}
                                    </div>
                                  </div>
                                )}

                                {/* TIE SECTION */}
                                <div className="space-y-4 pt-4 border-t border-slate-800/50">
                                  <div className="flex items-center justify-between">
                                    <span className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">
                                      Include Tie
                                    </span>
                                    <input
                                      type="checkbox"
                                      checked={options.hasTie}
                                      onChange={(e) =>
                                        handleOptionChange(
                                          "hasTie",
                                          e.target.checked
                                        )
                                      }
                                      // className="w-4 h-4 rounded text-indigo-500 bg-slate-800 border-slate-700"
                                      className="rounded text-indigo-500 bg-slate-800 border-slate-700"
                                      style={{ height: "17px", width: "17px" }}
                                    />
                                  </div>

                                  {options.hasTie && (
                                    <div className="grid grid-cols-2 gap-4 animate-in fade-in slide-in-from-top-1">
                                      <div className="space-y-2">
                                        <label className="text-[9px] font-bold text-slate-500 uppercase block">
                                          Tie Color
                                        </label>
                                        <input
                                          type="color"
                                          value={options.tieColor}
                                          onChange={(e) =>
                                            handleOptionChange(
                                              "tieColor",
                                              e.target.value
                                            )
                                          }
                                          className="w-full md:h-8 rounded-lg bg-slate-900 border border-slate-800"
                                        />
                                      </div>
                                      <div className="space-y-2">
                                        <label className="text-[9px] font-bold text-slate-500 uppercase block">
                                          Tie Pattern
                                        </label>
                                        <select
                                          value={options.tieStyle}
                                          onChange={(e) =>
                                            handleOptionChange(
                                              "tieStyle",
                                              e.target.value
                                            )
                                          }
                                          className="w-full md:h-8 bg-slate-900 border border-slate-800 rounded-lg px-2 text-[9px] outline-none font-bold uppercase"
                                        >
                                          {[
                                            "plain",
                                            "stripes",
                                            "dots",
                                            "stars",
                                            "textured",
                                            "random"
                                          ].map((s) => (
                                            <option key={s} value={s}>
                                              {s}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* GRADUATION MODE */}
                    {options.attireMode === "graduation" && (
                      <div className="space-y-8 animate-in fade-in slide-in-from-top-2 border-t border-slate-800/50 pt-8">
                        <div className="flex flex-col space-y-6">
                          <div className="flex flex-col space-y-4">
                            <div className="flex items-center justify-between">
                              <label className="text-[10px] font-bold text-slate-500 uppercase">
                                Academic Level
                              </label>
                              <div className="flex flex-wrap items-center justify-end gap-x-4 gap-y-2">
                                <label className="flex items-center space-x-2 cursor-pointer group">
                                  <input
                                    type="checkbox"
                                    checked={options.hasHood}
                                    onChange={(e) =>
                                      handleOptionChange(
                                        "hasHood",
                                        e.target.checked
                                      )
                                    }
                                    className="w-3.5 h-3.5 rounded text-indigo-500 border-slate-700 bg-slate-800"
                                  />
                                  <span className="text-[10px] font-bold text-slate-400 group-hover:text-slate-200 uppercase">
                                    Include Hood
                                  </span>
                                </label>
                                <label className="flex items-center space-x-2 cursor-pointer group">
                                  <input
                                    type="checkbox"
                                    checked={options.hasStole}
                                    onChange={(e) =>
                                      handleOptionChange(
                                        "hasStole",
                                        e.target.checked
                                      )
                                    }
                                    className="w-3.5 h-3.5 rounded text-indigo-500 border-slate-700 bg-slate-800"
                                  />
                                  <span className="text-[10px] font-bold text-slate-400 group-hover:text-slate-200 uppercase">
                                    Include Stole
                                  </span>
                                </label>
                              </div>
                            </div>
                            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                              {graduationStyles.map((style) => (
                                <button
                                  key={style}
                                  onClick={() =>
                                    handleOptionChange("gradStyle", style)
                                  }
                                  className={`py-2 px-3 rounded-xl text-[10px] font-bold border transition-all ${
                                    options.gradStyle === style
                                      ? "bg-indigo-600 border-indigo-500 text-white shadow-lg"
                                      : "bg-slate-900 border-slate-800 text-slate-500 hover:bg-slate-800"
                                  }`}
                                >
                                  {style.toUpperCase()}
                                </button>
                              ))}
                            </div>
                          </div>

                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="flex flex-col space-y-4 bg-slate-900/40 md:p-4 rounded-2xl border border-slate-800">
                              <div className="flex items-center justify-between">
                                <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">
                                  Gown Closure Type
                                </label>
                                <div className="flex bg-slate-950 rounded-lg p-1 border border-slate-800 w-48">
                                  <button
                                    onClick={() =>
                                      handleOptionChange(
                                        "gownClosureType",
                                        "zipper"
                                      )
                                    }
                                    className={`flex-1 py-1.5 rounded-md ml-5 mr-10 text-[9px] font-bold transition-all ${
                                      options.gownClosureType === "zipper"
                                        ? "bg-indigo-600 text-white shadow-sm"
                                        : "text-slate-500 hover:text-slate-300"
                                    }`}
                                  >
                                    ZIPPER
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleOptionChange(
                                        "gownClosureType",
                                        "tie-knot"
                                      )
                                    }
                                    className={`flex-1 py-1.5 rounded-md ml-10 mr-5 text-[9px] font-bold transition-all ${
                                      options.gownClosureType === "tie-knot"
                                        ? "bg-indigo-600 text-white shadow-sm"
                                        : "text-slate-500 hover:text-slate-300"
                                    }`}
                                  >
                                    TIE-KNOT
                                  </button>
                                </div>
                              </div>
                              <p className="text-[9px] text-slate-500 italic uppercase">
                                Zipper is modern; Tie-Knot is more traditional
                                academic styling.
                              </p>
                            </div>

                            <div className="flex flex-col space-y-4 bg-slate-900/40 md:p-4 rounded-2xl border border-slate-800">
                              <div className="flex items-center justify-between">
                                <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">
                                  Tassel Side
                                </label>
                                <div className="flex bg-slate-950 rounded-lg p-1 border border-slate-800 w-48">
                                  <button
                                    onClick={() =>
                                      handleOptionChange("tasselSide", "left")
                                    }
                                    className={`flex-1 py-1.5 rounded-md ml-5 mr-10 text-[9px] font-bold transition-all ${
                                      options.tasselSide === "left"
                                        ? "bg-indigo-600 text-white shadow-sm"
                                        : "text-slate-500 hover:text-slate-300"
                                    }`}
                                  >
                                    LEFT
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleOptionChange("tasselSide", "right")
                                    }
                                    className={`flex-1 py-1.5 rounded-md ml-10 mr-5 text-[9px] font-bold transition-all ${
                                      options.tasselSide === "right"
                                        ? "bg-indigo-600 text-white shadow-sm"
                                        : "text-slate-500 hover:text-slate-300"
                                    }`}
                                  >
                                    RIGHT
                                  </button>
                                </div>
                              </div>
                              <p className="text-[9px] text-slate-500 italic uppercase">
                                Left side is the default position for
                                graduation.
                              </p>
                            </div>
                          </div>
                        </div>

                        {/* <div className="grid grid-cols-2 md:grid-cols-7 gap-6 p-6 bg-slate-950/50 rounded-2xl border border-slate-800"> */}
                        <div className="grid grid-cols-2 md:grid-cols-7 gap-6 md:p-6 bg-slate-950/50 rounded-2xl border border-slate-800">
                          <div className="space-y-3">
                            <label className="text-[10px] font-bold text-slate-500 uppercase block">
                              Gown
                            </label>
                            <input
                              type="color"
                              value={options.gownColor}
                              onChange={(e) =>
                                handleOptionChange("gownColor", e.target.value)
                              }
                              className="w-8 md:h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                            />
                          </div>
                          <div className="space-y-3">
                            <label className="text-[10px] font-bold text-slate-500 uppercase block">
                              Cap/Tam
                            </label>
                            <input
                              type="color"
                              value={options.capColor}
                              onChange={(e) =>
                                handleOptionChange("capColor", e.target.value)
                              }
                              className="w-8 md:h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                            />
                          </div>
                          <div className="space-y-3">
                            <label className="text-[10px] font-bold text-slate-500 uppercase block">
                              Tassel
                            </label>
                            <input
                              type="color"
                              value={options.tasselColor}
                              onChange={(e) =>
                                handleOptionChange(
                                  "tasselColor",
                                  e.target.value
                                )
                              }
                              className="w-8 md:h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                            />
                          </div>
                          <div
                            className={`space-y-3 transition-opacity ${
                              !options.hasHood ? "opacity-30" : "opacity-100"
                            }`}
                          >
                            <label className="text-[10px] font-bold text-slate-500 uppercase block">
                              Hood
                            </label>
                            <input
                              type="color"
                              disabled={!options.hasHood}
                              value={options.hoodColor}
                              onChange={(e) =>
                                handleOptionChange("hoodColor", e.target.value)
                              }
                              className="w-8 md:h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                            />
                          </div>
                          <div
                            className={`space-y-3 transition-opacity ${
                              !options.hasStole ? "opacity-30" : "opacity-100"
                            }`}
                          >
                            <label className="text-[10px] font-bold text-slate-500 uppercase block">
                              Stole
                            </label>
                            <input
                              type="color"
                              disabled={!options.hasStole}
                              value={options.stoleColor}
                              onChange={(e) =>
                                handleOptionChange("stoleColor", e.target.value)
                              }
                              className="w-8 md:h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                            />
                          </div>
                          <div
                            className={`space-y-3 transition-opacity ${
                              !options.hasGradShirt
                                ? "opacity-30"
                                : "opacity-100"
                            }`}
                          >
                            <label className="text-[10px] font-bold text-slate-500 uppercase block">
                              Shirt
                            </label>
                            <input
                              type="color"
                              disabled={!options.hasGradShirt}
                              value={options.gradShirtColor}
                              onChange={(e) =>
                                handleOptionChange(
                                  "gradShirtColor",
                                  e.target.value
                                )
                              }
                              className="w-8 md:h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                            />
                          </div>
                          <div
                            className={`space-y-3 transition-opacity ${
                              !(options.hasGradShirt && options.hasGradTie)
                                ? "opacity-30"
                                : "opacity-100"
                            }`}
                          >
                            <label className="text-[10px] font-bold text-slate-500 uppercase block">
                              Tie
                            </label>
                            <input
                              type="color"
                              disabled={
                                !(options.hasGradShirt && options.hasGradTie)
                              }
                              value={options.gradTieColor}
                              onChange={(e) =>
                                handleOptionChange(
                                  "gradTieColor",
                                  e.target.value
                                )
                              }
                              className="w-8 md:h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                            />
                          </div>
                        </div>

                        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
                          <label className="flex items-center space-x-2 cursor-pointer group">
                            <input
                              type="checkbox"
                              checked={options.hasHood}
                              onChange={(e) =>
                                handleOptionChange("hasHood", e.target.checked)
                              }
                              className="w-3.5 h-3.5 rounded text-indigo-500 border-slate-700 bg-slate-800"
                            />
                            <span className="text-[10px] font-bold text-slate-400 group-hover:text-slate-200 uppercase">
                              Include Hood
                            </span>
                          </label>
                          <label className="flex items-center space-x-2 ml-20 cursor-pointer group">
                            <input
                              type="checkbox"
                              checked={options.hasStole}
                              onChange={(e) =>
                                handleOptionChange("hasStole", e.target.checked)
                              }
                              className="w-3.5 h-3.5 rounded text-indigo-500 border-slate-700 bg-slate-800"
                            />
                            <span className="text-[10px] font-bold text-slate-400 group-hover:text-slate-200 uppercase">
                              Include Stole
                            </span>
                          </label>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          <div className="bg-slate-900/40 md:p-4 rounded-2xl border border-slate-800 space-y-4">
                            <h4 className="text-[10px] font-bold text-slate-500 uppercase">
                              Regalia Accessories
                            </h4>
                            <div className="flex flex-col space-y-4">
                              <label className="flex items-center space-x-2 cursor-pointer group">
                                <input
                                  type="checkbox"
                                  checked={options.hasGradShirt}
                                  onChange={(e) =>
                                    handleOptionChange(
                                      "hasGradShirt",
                                      e.target.checked
                                    )
                                  }
                                  className="w-3.5 h-3.5 rounded text-indigo-500 border-slate-700 bg-slate-800"
                                />
                                <span className="text-[10px] font-bold text-slate-400 group-hover:text-slate-200 uppercase">
                                  Button-Down Shirt
                                </span>
                              </label>
                              <label
                                className={`flex items-center space-x-2 cursor-pointer group transition-opacity ${
                                  !options.hasGradShirt
                                    ? "opacity-30 pointer-events-none"
                                    : "opacity-100"
                                }`}
                              >
                                <input
                                  type="checkbox"
                                  disabled={!options.hasGradShirt}
                                  checked={options.hasGradTie}
                                  onChange={(e) =>
                                    handleOptionChange(
                                      "hasGradTie",
                                      e.target.checked
                                    )
                                  }
                                  className="w-3.5 h-3.5 rounded text-indigo-500 border-slate-700 bg-slate-800"
                                />
                                <span className="text-[10px] font-bold text-slate-400 group-hover:text-slate-200 uppercase">
                                  Add Tie
                                </span>
                              </label>
                              <div className="h-px bg-slate-800 my-1" />
                              <div className="space-y-2">
                                <label className="flex items-center space-x-3 cursor-pointer group">
                                  <input
                                    type="checkbox"
                                    checked={options.hasSash}
                                    onChange={(e) =>
                                      handleOptionChange(
                                        "hasSash",
                                        e.target.checked
                                      )
                                    }
                                    // className="w-4 h-4 rounded text-indigo-500"
                                    className="w-3.5 h-3.5 rounded text-indigo-500"
                                  />
                                  <span className="text-xs">Academic Sash</span>
                                </label>
                                {options.hasSash && (
                                  <div className="pl-7 animate-in slide-in-from-top-1">
                                    <div className="flex items-center space-x-3 bg-slate-950/50 p-2 rounded-xl border border-slate-800">
                                      <input
                                        type="color"
                                        value={
                                          options.hasSash
                                            ? options.sashColor
                                            : "#000000"
                                        }
                                        onChange={(e) =>
                                          handleOptionChange(
                                            "sashColor",
                                            e.target.value
                                          )
                                        }
                                        // className="w-6 h-6 rounded-lg cursor-pointer"
                                        className="md:h-6 rounded-lg cursor-pointer"
                                        style={{ width: "150px" }}
                                      />
                                      <span className="text-[10px] font-mono text-indigo-400 font-bold uppercase">
                                        {options.sashColor}
                                      </span>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="space-y-2">
                                <label className="flex items-center space-x-3 cursor-pointer group">
                                  <input
                                    type="checkbox"
                                    checked={options.hasRibbon}
                                    onChange={(e) =>
                                      handleOptionChange(
                                        "hasRibbon",
                                        e.target.checked
                                      )
                                    }
                                    // className="w-4 h-4 rounded text-indigo-500"
                                    className="w-3.5 h-3.5 rounded text-indigo-500"
                                  />
                                  <span className="text-xs">
                                    Ceremonial Ribbon
                                  </span>
                                </label>
                                {options.hasRibbon && (
                                  <div className="pl-7 animate-in slide-in-from-top-1">
                                    <div className="flex items-center space-x-3 bg-slate-950/50 p-2 rounded-xl border border-slate-800">
                                      <input
                                        type="color"
                                        value={
                                          options.hasRibbon
                                            ? options.ribbonColor
                                            : "#000000"
                                        }
                                        onChange={(e) =>
                                          handleOptionChange(
                                            "ribbonColor",
                                            e.target.value
                                          )
                                        }
                                        // className="w-6 h-6 rounded-lg cursor-pointer"
                                        className="md:h-6 rounded-lg cursor-pointer"
                                        style={{ width: "150px" }}
                                      />
                                      <span className="text-[10px] font-mono text-indigo-400 font-bold uppercase">
                                        {options.ribbonColor}
                                      </span>
                                    </div>
                                  </div>
                                )}
                              </div>

                              <div className="h-px bg-slate-800 my-1" />
                              <div className="space-y-3">
                                <label className="flex items-center space-x-3 cursor-pointer group">
                                  <input
                                    type="checkbox"
                                    checked={options.hasHonorCord}
                                    onChange={(e) =>
                                      handleOptionChange(
                                        "hasHonorCord",
                                        e.target.checked
                                      )
                                    }
                                    // className="w-4 h-4 rounded text-indigo-500"
                                    className="w-3.5 h-3.5 rounded text-indigo-500"
                                  />
                                  <span className="text-xs font-bold text-slate-300">
                                    Honor Cords
                                  </span>
                                </label>
                                {options.hasHonorCord && (
                                  <div className="pl-7 space-y-4 animate-in slide-in-from-top-1">
                                    <div className="space-y-2">
                                      <label className="text-[9px] font-bold text-slate-500 uppercase tracking-widest block">
                                        Select Honor Society
                                      </label>
                                      <select
                                        value={options.honorSociety}
                                        onChange={(e) => {
                                          const soc = honorSocieties.find(
                                            (s) => s.name === e.target.value
                                          );
                                          if (soc) {
                                            handleOptionChange(
                                              "honorSociety",
                                              soc.name
                                            );
                                            handleOptionChange(
                                              "honorCordColor",
                                              soc.color
                                            );
                                          }
                                        }}
                                        className="w-full md:h-8 bg-slate-950 border border-slate-800 rounded-lg px-2 text-[10px] outline-none font-bold text-indigo-400"
                                      >
                                        {honorSocieties.map((s) => (
                                          <option key={s.name} value={s.name}>
                                            {s.name.toUpperCase()}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                    <div className="flex items-center space-x-3 bg-slate-950/50 p-2 rounded-xl border border-slate-800">
                                      <input
                                        type="color"
                                        value={options.honorCordColor}
                                        onChange={(e) =>
                                          handleOptionChange(
                                            "honorCordColor",
                                            e.target.value
                                          )
                                        }
                                        // className="w-6 h-6 rounded-lg cursor-pointer bg-transparent"
                                        className="md:h-6 rounded-lg cursor-pointer bg-transparent"
                                        style={{ width: "150px" }}
                                      />
                                      <div className="flex flex-col">
                                        <span className="text-[9px] font-mono text-indigo-300 uppercase font-bold">
                                          {options.honorCordColor}
                                        </span>
                                        <span className="text-[9px] text-slate-600 uppercase">
                                          Cord Color
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="bg-slate-900/40 md:p-4 rounded-2xl border border-slate-800 space-y-4">
                            <h4 className="text-[10px] font-bold text-slate-500 uppercase">
                              Portrait Prop
                            </h4>
                            <div className="grid grid-cols-2 gap-2 pb-2 border-b border-slate-800/50 mb-2">
                              {graduationProps.map((prop) => (
                                <button
                                  key={prop.value}
                                  onClick={() =>
                                    handleOptionChange("gradProp", prop.value)
                                  }
                                  className={`py-1.5 px-2 rounded-lg text-[9px] font-bold border transition-all ${
                                    options.gradProp === prop.value
                                      ? "bg-indigo-600 text-white"
                                      : "bg-slate-950 border-slate-800 text-slate-500"
                                  }`}
                                >
                                  {prop.label.toUpperCase()}
                                </button>
                              ))}
                            </div>
                            {options.gradProp === "scroll" && (
                              <div className="space-y-3 animate-in fade-in slide-in-from-top-1">
                                <label className="text-[10px] font-bold text-slate-500 uppercase block">
                                  Scroll Ribbon Color
                                </label>
                                <div className="flex items-center space-x-3 bg-slate-950/50 p-2 rounded-xl border border-slate-800">
                                  <input
                                    type="color"
                                    value={options.scrollRibbonColor}
                                    onChange={(e) =>
                                      handleOptionChange(
                                        "scrollRibbonColor",
                                        e.target.value
                                      )
                                    }
                                    // className="w-6 h-6 rounded-lg cursor-pointer bg-transparent border-none p-0"
                                    className="md:h-6 rounded-lg cursor-pointer bg-transparent border-none p-0"
                                    style={{ width: "150px" }}
                                  />
                                  <div className="flex flex-col">
                                    <span className="text-[10px] font-mono text-indigo-400 font-bold uppercase">
                                      {options.scrollRibbonColor}
                                    </span>
                                    <span className="text-[9px] text-slate-600 font-bold uppercase">
                                      Ribbon tied to scroll
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {/* UNIFORM MODE */}
                    {options.attireMode === "uniform" && (
                      <div className="space-y-8 animate-in fade-in slide-in-from-top-2 border-t border-slate-800/50 pt-8">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                          <div className="space-y-4">
                            <label className="text-xs font-bold text-slate-500 uppercase tracking-widest block">
                              Uniform Type
                            </label>
                            <div className="grid grid-cols-2 gap-3">
                              {[
                                { type: "collar", label: "Collar Shirt" },
                                { type: "checkered", label: "Checkered" },
                                { type: "striped", label: "Striped" },
                                { type: "polo", label: "Polo T-Shirt" },
                                { type: "blouse", label: "Blouse (Girls)" },
                                { type: "pinafore", label: "Pinafore (Girls)" }
                              ].map(({ type, label }) => (
                                <button
                                  key={type}
                                  onClick={() =>
                                    handleOptionChange("uniformType", type)
                                  }
                                  className={`py-2 px-3 rounded-xl text-[10px] font-bold border transition-all ${
                                    options.uniformType === type
                                      ? "bg-indigo-600 border-indigo-500 text-white"
                                      : "bg-slate-900 border-slate-800 text-slate-500 hover:bg-slate-800"
                                  }`}
                                >
                                  {label.toUpperCase()}
                                </button>
                              ))}
                            </div>

                            {(options.uniformType === "pinafore" ||
                              options.uniformType === "blouse") && (
                              <div className="bg-indigo-950/20 border border-indigo-500/20 p-3 rounded-xl animate-in slide-in-from-top-1">
                                <p className="text-[9px] text-indigo-400 font-bold uppercase tracking-tight flex items-start space-x-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-3.5 w-3.5 mt-0.5"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                  <span>
                                    Restricted to Female subjects. Males will
                                    default to professional attire.
                                  </span>
                                </p>
                              </div>
                            )}

                            <div className="pt-4 space-y-4">
                              <label className="text-xs font-bold text-slate-500 uppercase tracking-widest block">
                                {options.uniformType === "pinafore"
                                  ? "Pinafore Dress Color"
                                  : "Base Color"}
                              </label>
                              <div className="flex items-center space-x-4 bg-slate-900/50 p-3 rounded-2xl border border-slate-800">
                                <input
                                  type="color"
                                  value={options.uniformColor}
                                  onChange={(e) =>
                                    handleOptionChange(
                                      "uniformColor",
                                      e.target.value
                                    )
                                  }
                                  className="md:w-10 md:h-10 rounded-lg cursor-pointer bg-transparent border-none p-0"
                                />
                                <div
                                  className="flex-1 md:h-10 rounded-lg border border-slate-700 flex items-center px-3 bg-slate-900 font-mono text-xs uppercase"
                                  style={{ color: options.uniformColor }}
                                >
                                  {options.uniformColor}
                                </div>
                              </div>
                            </div>

                            {options.uniformType === "striped" && (
                              <div className="pt-2 space-y-4 animate-in slide-in-from-top-2">
                                <div className="space-y-4 bg-slate-900/40 md:p-4 rounded-2xl border border-slate-800">
                                  <div className="space-y-2">
                                    <label className="text-xs font-bold text-slate-500 uppercase tracking-widest block">
                                      Stripe Color
                                    </label>
                                    <div className="flex items-center space-x-4">
                                      <input
                                        type="color"
                                        value={options.uniformStripeColor}
                                        onChange={(e) =>
                                          handleOptionChange(
                                            "uniformStripeColor",
                                            e.target.value
                                          )
                                        }
                                        className="md:w-10 md:h-10 rounded-lg cursor-pointer bg-transparent border-none p-0"
                                      />
                                      <div className="flex flex-col">
                                        <span className="text-xs font-mono text-indigo-400 font-bold">
                                          {options.uniformStripeColor.toUpperCase()}
                                        </span>
                                        <span className="text-[9px] text-slate-600 font-bold uppercase">
                                          Stripe Color
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="space-y-2 border-t border-slate-800 pt-3">
                                    <label className="text-xs font-bold text-slate-500 uppercase tracking-widest block">
                                      Stripe Thickness
                                    </label>
                                    <div className="flex bg-slate-950 rounded-xl p-1 space-x-1">
                                      {["thin", "medium", "thick"].map((w) => (
                                        <button
                                          key={w}
                                          onClick={() =>
                                            handleOptionChange(
                                              "uniformStripeWidth",
                                              w
                                            )
                                          }
                                          className={`flex-1 py-1.5 rounded-lg text-[9px] font-bold transition-all ${
                                            options.uniformStripeWidth === w
                                              ? "bg-indigo-600 text-white shadow-md"
                                              : "text-slate-600 hover:text-slate-400"
                                          }`}
                                        >
                                          {w.toUpperCase()}
                                        </button>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {options.uniformType !== "pinafore" && (
                              <div className="space-y-3 pt-4">
                                <div className="flex items-center justify-between">
                                  <label className="text-xs font-bold text-slate-500 uppercase tracking-widest">
                                    Add Uniform Tie
                                  </label>
                                  <input
                                    type="checkbox"
                                    checked={options.hasUniformTie}
                                    onChange={(e) =>
                                      handleOptionChange(
                                        "hasUniformTie",
                                        e.target.checked
                                      )
                                    }
                                    className="w-3.5 h-3.5 rounded text-indigo-500"
                                  />
                                </div>
                                {options.hasUniformTie && (
                                  <div className="flex items-center space-x-4 bg-slate-900/50 p-3 rounded-2xl border border-slate-800 animate-in fade-in slide-in-from-top-1">
                                    <input
                                      type="color"
                                      value={options.uniformTieColor}
                                      onChange={(e) =>
                                        handleOptionChange(
                                          "uniformTieColor",
                                          e.target.value
                                        )
                                      }
                                      // className="w-8 h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                                      className="md:h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                                      style={{ width: "150px" }}
                                    />
                                    <span className="text-[10px] font-mono text-slate-500 uppercase">
                                      {options.uniformTieColor}
                                    </span>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>

                          {/* PINAFORE SPECIFIC SHIRT SETTINGS */}
                          {options.uniformType === "pinafore" && (
                            <div className="space-y-6 bg-slate-900/40 md:p-6 rounded-3xl border border-indigo-500/30 animate-in fade-in slide-in-from-right-2">
                              <h4 className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest border-b border-indigo-500/20 pb-2 mb-4">
                                Matching Blouse Settings
                              </h4>
                              <div className="space-y-6">
                                <div className="space-y-3">
                                  <label className="text-[10px] font-bold text-slate-500 uppercase block">
                                    Blouse Color
                                  </label>
                                  <div className="flex items-center space-x-4 bg-slate-950/50 p-2 rounded-xl border border-slate-800">
                                    <input
                                      type="color"
                                      value={options.pinaforeShirtColor}
                                      onChange={(e) =>
                                        handleOptionChange(
                                          "pinaforeShirtColor",
                                          e.target.value
                                        )
                                      }
                                      className="w-8 md:h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                                    />
                                    <span className="text-[10px] font-mono text-slate-400 uppercase">
                                      {options.pinaforeShirtColor}
                                    </span>
                                  </div>
                                </div>

                                <div className="space-y-3">
                                  <label className="text-[10px] font-bold text-slate-500 uppercase block">
                                    Blouse Pattern
                                  </label>
                                  <div className="flex bg-slate-950 rounded-xl p-1 border border-slate-800">
                                    <button
                                      onClick={() =>
                                        handleOptionChange(
                                          "pinaforeShirtPattern",
                                          "plain"
                                        )
                                      }
                                      className={`flex-1 py-1.5 rounded-lg text-[9px] font-bold transition-all ${
                                        options.pinaforeShirtPattern === "plain"
                                          ? "bg-indigo-600 text-white shadow-md"
                                          : "text-slate-500 hover:text-slate-300"
                                      }`}
                                    >
                                      PLAIN
                                    </button>
                                    <button
                                      onClick={() =>
                                        handleOptionChange(
                                          "pinaforeShirtPattern",
                                          "striped"
                                        )
                                      }
                                      className={`flex-1 py-1.5 rounded-lg text-[9px] font-bold transition-all ${
                                        options.pinaforeShirtPattern ===
                                        "striped"
                                          ? "bg-indigo-600 text-white shadow-md"
                                          : "text-slate-500 hover:text-slate-300"
                                      }`}
                                    >
                                      STRIPED
                                    </button>
                                  </div>
                                </div>

                                {options.pinaforeShirtPattern === "striped" && (
                                  <div className="space-y-4 animate-in slide-in-from-top-1 bg-slate-950/50 p-3 rounded-xl border border-slate-800">
                                    <div className="space-y-2">
                                      <label className="text-[10px] font-bold text-slate-500 uppercase block">
                                        Stripe Color
                                      </label>
                                      <div className="flex items-center space-x-3">
                                        <input
                                          type="color"
                                          value={
                                            options.pinaforeShirtStripeColor
                                          }
                                          onChange={(e) =>
                                            handleOptionChange(
                                              "pinaforeShirtStripeColor",
                                              e.target.value
                                            )
                                          }
                                          className="w-8 md:h-8 rounded-lg cursor-pointer bg-transparent border-none p-0"
                                        />
                                        <span className="text-[10px] font-mono text-slate-400 uppercase">
                                          {options.pinaforeShirtStripeColor}
                                        </span>
                                      </div>
                                    </div>
                                    <div className="space-y-2">
                                      <label className="text-[10px] font-bold text-slate-500 uppercase block">
                                        Stripe Thickness
                                      </label>
                                      <div className="flex bg-slate-900 rounded-lg p-1 space-x-1">
                                        {["thin", "medium", "thick"].map(
                                          (w) => (
                                            <button
                                              key={w}
                                              onClick={() =>
                                                handleOptionChange(
                                                  "pinaforeShirtStripeWidth",
                                                  w
                                                )
                                              }
                                              // className={`flex-1 py-1 rounded text-[8px] font-bold transition-all ${
                                              className={`flex-1 text-[9px] font-bold transition-all ${
                                                options.pinaforeShirtStripeWidth ===
                                                w
                                                  ? // ? "bg-indigo-600 text-white"
                                                    // : "text-slate-600 hover:text-slate-400"
                                                    "bg-indigo-600 text-white"
                                                  : "text-slate-500 hover:text-slate-400"
                                              }`}
                                              style={{ height: "20px" }}
                                            >
                                              {w.toUpperCase()}
                                            </button>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )}

                                <div className="space-y-3">
                                  <label className="text-[10px] font-bold text-slate-500 uppercase block">
                                    Sleeve Length
                                  </label>
                                  <div className="flex bg-slate-950 rounded-xl p-1 border border-slate-800">
                                    <button
                                      onClick={() =>
                                        handleOptionChange(
                                          "pinaforeShirtSleeves",
                                          "short"
                                        )
                                      }
                                      className={`flex-1 py-1.5 rounded-lg text-[9px] font-bold transition-all ${
                                        options.pinaforeShirtSleeves === "short"
                                          ? "bg-indigo-600 text-white shadow-md"
                                          : "text-slate-500 hover:text-slate-300"
                                      }`}
                                    >
                                      SHORT
                                    </button>
                                    <button
                                      onClick={() =>
                                        handleOptionChange(
                                          "pinaforeShirtSleeves",
                                          "long"
                                        )
                                      }
                                      className={`flex-1 py-1.5 rounded-lg text-[9px] font-bold transition-all ${
                                        options.pinaforeShirtSleeves === "long"
                                          ? "bg-indigo-600 text-white shadow-md"
                                          : "text-slate-500 hover:text-slate-300"
                                      }`}
                                    >
                                      LONG
                                    </button>
                                  </div>
                                </div>

                                {options.pinaforeShirtSleeves === "short" && (
                                  <div className="space-y-3 animate-in fade-in slide-in-from-top-1">
                                    <label className="text-[10px] font-bold text-slate-500 uppercase block">
                                      Short Sleeve Style
                                    </label>
                                    <div className="flex bg-slate-950 rounded-xl p-1 border border-slate-800">
                                      <button
                                        onClick={() =>
                                          handleOptionChange(
                                            "pinaforeSleeveCuff",
                                            "plain"
                                          )
                                        }
                                        className={`flex-1 py-1.5 rounded-lg text-[9px] font-bold transition-all ${
                                          options.pinaforeSleeveCuff === "plain"
                                            ? "bg-indigo-600 text-white shadow-md"
                                            : "text-slate-500 hover:text-slate-300"
                                        }`}
                                      >
                                        PLAIN CUFF
                                      </button>
                                      <button
                                        onClick={() =>
                                          handleOptionChange(
                                            "pinaforeSleeveCuff",
                                            "elasticated"
                                          )
                                        }
                                        className={`flex-1 py-1.5 rounded-lg text-[9px] font-bold transition-all ${
                                          options.pinaforeSleeveCuff ===
                                          "elasticated"
                                            ? "bg-indigo-600 text-white shadow-md"
                                            : "text-slate-500 hover:text-slate-300"
                                        }`}
                                      >
                                        ELASTICATED
                                      </button>
                                    </div>
                                    <p className="text-[9px] text-slate-600 uppercase font-bold text-center">
                                      Elasticated creates a gentle puff sleeve
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {/* CASUAL MODE */}
                    {options.attireMode === "casual" && (
                      <div className="space-y-8 animate-in fade-in slide-in-from-top-2 border-t border-slate-800/50 pt-8">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                          {/* TOPS SECTION */}
                          <div className="space-y-6 bg-slate-900/40 md:p-6 rounded-3xl border border-slate-800">
                            <h4 className="text-xs font-bold text-slate-400 uppercase tracking-widest border-b border-slate-800 pb-3">
                              Tops
                            </h4>
                            <div className="grid grid-cols-2 gap-2">
                              {[
                                { type: "shirt-plain", label: "Plain Shirt" },
                                {
                                  type: "shirt-checked",
                                  label: "Checked Shirt"
                                },
                                {
                                  type: "shirt-striped",
                                  label: "Striped Shirt"
                                },
                                { type: "tshirt", label: "T-Shirt" },
                                { type: "sweatshirt", label: "Sweatshirt" },
                                { type: "croptop", label: "Crop Top (Girls)" },
                                { type: "short-top", label: "Short Top" },
                                { type: "long-top", label: "Long Top" },
                                { type: "turtle-neck", label: "Turtle Neck" },
                                {
                                  type: "oversized-tshirt",
                                  label: "Oversized T-Shirt"
                                }
                              ].map(({ type, label }) => (
                                <button
                                  key={type}
                                  onClick={() =>
                                    handleOptionChange("casualTopType", type)
                                  }
                                  className={`py-2 px-1 rounded-lg text-[9px] font-bold border transition-all ${
                                    options.casualTopType === type
                                      ? "bg-indigo-600 text-white"
                                      : "bg-slate-950 border-slate-800 text-slate-600"
                                  }`}
                                >
                                  {label.toUpperCase()}
                                </button>
                              ))}
                            </div>
                            <div className="flex items-center space-x-4 bg-slate-950/50 p-3 rounded-xl border border-slate-800">
                              <input
                                type="color"
                                value={options.casualTopColor}
                                onChange={(e) =>
                                  handleOptionChange(
                                    "casualTopColor",
                                    e.target.value
                                  )
                                }
                                className="w-8 md:h-8 rounded-lg cursor-pointer"
                              />
                              <span className="text-[10px] font-mono text-slate-500 uppercase">
                                Top Color: {options.casualTopColor}
                              </span>
                            </div>
                          </div>

                          {/* OUTERWEAR SECTION */}
                          <div className="space-y-6 bg-slate-900/40 md:p-6 rounded-3xl border border-slate-800">
                            <h4 className="text-xs font-bold text-slate-400 uppercase tracking-widest border-b border-slate-800 pb-3">
                              Outerwear
                            </h4>
                            <div className="grid grid-cols-2 gap-2">
                              {[
                                { type: "hoodie", label: "Hoodie" },
                                {
                                  type: "oversized-hoodie",
                                  label: "Oversized Hoodie"
                                },
                                { type: "zip-jacket", label: "Zip Jacket" },
                                { type: "denim-jacket", label: "Denim Jacket" },
                                { type: "sweater", label: "Sweater" },
                                { type: "none", label: "None" }
                              ].map(({ type, label }) => (
                                <button
                                  key={type}
                                  onClick={() =>
                                    handleOptionChange("casualOuterType", type)
                                  }
                                  className={`py-2 px-1 rounded-lg text-[9px] font-bold border transition-all ${
                                    options.casualOuterType === type
                                      ? "bg-indigo-600 text-white"
                                      : "bg-slate-950 border-slate-800 text-slate-600"
                                  }`}
                                >
                                  {label.toUpperCase()}
                                </button>
                              ))}
                            </div>

                            {/* SWEATER STYLE SELECTION */}
                            {options.casualOuterType === "sweater" && (
                              <div className="space-y-4 pt-2 border-t border-slate-800 animate-in fade-in slide-in-from-top-2 duration-300">
                                <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest block">
                                  Sweater Knit Style
                                </label>
                                <div className="grid grid-cols-2 gap-2">
                                  {[
                                    { type: "crew-neck", label: "Crew Neck" },
                                    { type: "v-neck", label: "V-Neck" },
                                    {
                                      type: "cable-knit",
                                      label: "Chunk/Cable Knit"
                                    },
                                    { type: "vest", label: "Vest" },
                                    { type: "fair-isle", label: "Fair Isle" }
                                  ].map(({ type, label }) => (
                                    <button
                                      key={type}
                                      onClick={() =>
                                        handleOptionChange(
                                          "casualSweaterStyle",
                                          type
                                        )
                                      }
                                      className={`py-2 px-1 rounded-lg text-[9px] font-bold border transition-all ${
                                        options.casualSweaterStyle === type
                                          ? "bg-indigo-500 border-400 text-white"
                                          : "bg-slate-950 border-slate-800 text-slate-600"
                                      }`}
                                    >
                                      {label.toUpperCase()}
                                    </button>
                                  ))}
                                </div>
                              </div>
                            )}

                            {options.casualOuterType !== "none" && (
                              <div className="flex items-center space-x-4 bg-slate-950/50 p-3 rounded-xl border border-slate-800">
                                <input
                                  type="color"
                                  value={options.casualOuterColor}
                                  onChange={(e) =>
                                    handleOptionChange(
                                      "casualOuterColor",
                                      e.target.value
                                    )
                                  }
                                  className="w-8 md:h-8 rounded-lg cursor-pointer"
                                />
                                <span className="text-[10px] font-mono text-slate-500 uppercase">
                                  Outer Color: {options.casualOuterColor}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {/* KEEP ORIGINAL MODE */}
                    {options.attireMode === "keepOriginal" && (
                      <div className="flex flex-col items-center justify-center p-12 text-slate-600 border-2 border-dashed border-slate-800 rounded-[2rem] animate-in fade-in border-t border-slate-800/50 pt-8">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="md:h-10 md:w-10 mb-4 opacity-20"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                          />
                        </svg>
                        <p className="text-sm font-bold uppercase tracking-widest">
                          No Dress Changes
                        </p>
                        <p className="text-[10px] max-w-[200px] text-center mt-2 opacity-60 italic">
                          We will strictly maintain the clothing from your
                          source image.
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {/* FACE & GROOMING SECTION */}
                <div
                  className={`pt-8 border-t border-slate-800 space-y-6 ${
                    activeTab === "settings" || !mobile
                      ? "block"
                      : "hidden lg:block"
                  }`}
                >
                  <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider">
                    Face & Grooming
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {!hasGroupImages && (
                      <div className="space-y-4">
                        <label className="text-xs font-bold text-slate-500 block">
                          Facial Hair & Grooming
                        </label>
                        <div className="flex flex-col space-y-4">
                          <div className="space-y-2">
                            <span className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">
                              Beard/Mustache
                            </span>
                            {[
                              {
                                val: "default",
                                label: "No Change / Default Grooming"
                              },
                              {
                                val: "keep",
                                label: "Keep Original Beard/Mustache"
                              },
                              { val: "clone", label: "Clone Reference" },
                              { val: "shaven", label: "Clean Shaven" }
                            ].map((item) => (
                              <React.Fragment key={item.val}>
                                <label
                                  className={`flex items-center space-x-3 cursor-pointer group ${
                                    item.val === "clone" && !maleRef
                                      ? "opacity-30 pointer-events-none"
                                      : ""
                                  }`}
                                >
                                  <input
                                    type="radio"
                                    name="facialHair"
                                    disabled={item.val === "clone" && !maleRef}
                                    checked={options.facialHair === item.val}
                                    onChange={() =>
                                      handleOptionChange("facialHair", item.val)
                                    }
                                    // className="w-4 h-4 text-indigo-600 bg-slate-800 border-slate-700"
                                    className="text-indigo-600 bg-slate-800 border-slate-700"
                                    style={{
                                      height: "15px",
                                      width: "15px",
                                      marginTop: "-2px"
                                    }}
                                  />
                                  <span className="text-sm text-slate-400 group-hover:text-slate-200">
                                    {item.label}
                                  </span>
                                </label>
                                {item.val === "shaven" &&
                                  options.facialHair === "shaven" && (
                                    <div className="pl-7 animate-in slide-in-from-top-1">
                                      <label className="flex items-center space-x-2 cursor-pointer group">
                                        <input
                                          type="checkbox"
                                          checked={options.keepMustache}
                                          onChange={(e) =>
                                            handleOptionChange(
                                              "keepMustache",
                                              e.target.checked
                                            )
                                          }
                                          className="w-3.5 h-3.5 rounded text-indigo-500 bg-slate-800 border-slate-700"
                                        />
                                        <span className="text-[10px] font-bold text-slate-500 group-hover:text-slate-400 uppercase">
                                          Keep Original Mustache
                                        </span>
                                      </label>
                                    </div>
                                  )}
                              </React.Fragment>
                            ))}
                          </div>

                          <div className="space-y-2 pt-4 border-t border-slate-800/50">
                            <span className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">
                              Hair Style Control
                            </span>
                            {[
                              {
                                val: "keep",
                                label: "Strict Hair Preservation (1:1)"
                              },
                              {
                                val: "groom",
                                label: "Professional Groomed Hair"
                              },
                              {
                                val: "match-ref",
                                label: "Adopt Reference Hair Style"
                              }
                            ].map((item) => (
                              <label
                                key={item.val}
                                className={`flex items-center space-x-3 cursor-pointer group ${
                                  item.val === "match-ref" && !hasReference
                                    ? "opacity-30 pointer-events-none"
                                    : ""
                                }`}
                              >
                                <input
                                  type="radio"
                                  name="hairStyle"
                                  disabled={
                                    item.val === "match-ref" && !hasReference
                                  }
                                  checked={options.hairStyle === item.val}
                                  onChange={() =>
                                    handleOptionChange("hairStyle", item.val)
                                  }
                                  // className="w-4 h-4 text-indigo-600 bg-slate-800 border-slate-700"
                                  className="text-indigo-600 bg-slate-800 border-slate-700"
                                  style={{
                                    height: "15px",
                                    width: "15px",
                                    marginTop: "-2px"
                                  }}
                                />
                                <span className="text-sm text-slate-400 group-hover:text-slate-200">
                                  {item.label}
                                </span>
                              </label>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="grid grid-cols-1 gap-3">
                      {[
                        { k: "keepEyewear", l: "Keep Original Eyewear" },
                        {
                          k: "keepFacialChars",
                          l: "Keep Facial Characteristics"
                        },
                        {
                          k: "noBlemishes",
                          l: "No Blemishes (Remove Spots/Acne)"
                        }
                      ]
                        .filter(
                          (item) =>
                            !hasGroupImages ||
                            (item.k !== "keepEyewear" &&
                              item.k !== "keepFacialChars")
                        )
                        .map((item) => (
                          <div key={item.k} className="space-y-2">
                            <label className="flex items-center space-x-3 cursor-pointer group">
                              <input
                                type="checkbox"
                                checked={options[item.k]}
                                onChange={(e) =>
                                  handleOptionChange(item.k, e.target.checked)
                                }
                                // className="w-4 h-4 rounded text-indigo-500 border-slate-700 bg-slate-800"
                                className="rounded text-indigo-500 border-slate-700 bg-slate-800"
                                style={{
                                  height: "15px",
                                  width: "15px",
                                  marginTop: "-2px"
                                }}
                              />
                              <span className="text-sm text-slate-400 group-hover:text-slate-200">
                                {item.l}
                              </span>
                            </label>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>

                {/* ENVIRONMENT, LIGHTING & SIZE SECTION */}
                <div
                  className={`pt-8 border-t border-slate-800 space-y-6 ${
                    activeTab === "settings" || !mobile
                      ? "block"
                      : "hidden lg:block"
                  }`}
                >
                  <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider">
                    Environment, Lighting & Framing
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {!groupMembers.some((m) => m.image !== null) ? (
                      <div className="space-y-4">
                        <div className="space-y-3">
                          <label className="text-xs font-bold text-slate-500">
                            Expression Selection
                          </label>
                          <select
                            value={options.expression}
                            onChange={(e) =>
                              handleOptionChange("expression", e.target.value)
                            }
                            className="w-full md:h-10 bg-slate-900 border border-slate-700 rounded-lg px-3 text-xs outline-none font-bold"
                          >
                            <option value="original">
                              Strictly Keep Original Expression (1:1)
                            </option>
                            <option value="smile">
                              Professional Studio Smile
                            </option>
                            <option value="confident">
                              Professional & Confident (Neutral)
                            </option>
                          </select>
                          <p className="text-[9px] text-indigo-400 font-bold uppercase tracking-tight mt-1">
                            {options.expression === "original"
                              ? "Identity Locked: Mouth and gaze will not be altered."
                              : "Note: AI may subtly shift facial features for the chosen expression."}
                          </p>
                        </div>

                        <div className="space-y-3 pt-2">
                          <label className="text-xs font-bold text-slate-500">
                            Posture Selection
                          </label>
                          <select
                            value={options.posture}
                            onChange={(e) =>
                              handleOptionChange("posture", e.target.value)
                            }
                            className="w-full md:h-10 bg-slate-900 border border-slate-700 rounded-lg px-3 text-xs outline-none font-bold"
                          >
                            <option value="original">
                              Keep original posture
                            </option>
                            <option value="clone">
                              Clone Reference Posture
                            </option>
                            <option value="professional">Professional</option>
                            <option value="casual">Casual</option>
                          </select>
                          {options.posture === "clone" && !hasReference && (
                            <p className="text-[9px] text-amber-500 font-bold uppercase tracking-tight mt-1">
                              No reference uploaded. Posture will default to
                              original.
                            </p>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="flex items-center justify-center bg-slate-900/30 rounded-2xl md:p-6 border border-dashed border-slate-800">
                        <p className="text-[10px] text-slate-500 font-bold uppercase tracking-widest text-center leading-relaxed">
                          <span className="text-indigo-400 block mb-1">
                            Group Mode Active
                          </span>
                          Expression & Posture are managed individually in the
                          Group Source Studio.
                        </p>
                      </div>
                    )}

                    <div className="space-y-3">
                      <label className="text-xs font-bold text-slate-500">
                        Output Size / Aspect ratio
                      </label>
                      <select
                        value={options.aspectRatio}
                        onChange={(e) =>
                          handleOptionChange("aspectRatio", e.target.value)
                        }
                        className="w-full md:h-10 bg-slate-900 border border-slate-700 rounded-lg px-3 text-xs outline-none"
                      >
                        <option value="1:1">1:1 Square</option>
                        <option value="3:4">3:4 Portrait</option>
                        <option value="4:3">4:3 Landscape</option>
                        <option value="9:16">9:16 Full-Portrait</option>
                        <option value="16:9">16:9 Cinematic</option>
                      </select>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 pt-4 border-t border-slate-800/30">
                    <div className="col-span-full mb-2">
                      <div className="bg-slate-900/40 md:p-4 rounded-2xl border border-slate-800 space-y-3">
                        <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest block">
                          Studio Lighting Mode
                        </label>
                        <div className="grid grid-cols-2 gap-3">
                          <button
                            onClick={() =>
                              handleOptionChange("lightingMode", "even")
                            }
                            className={`py-2 px-3 rounded-xl text-[10px] font-bold border transition-all flex items-center justify-center space-x-2 ${
                              options.lightingMode === "even"
                                ? "bg-indigo-600 border-indigo-500 text-white shadow-lg shadow-indigo-500/20"
                                : "bg-slate-950 border-slate-800 text-slate-500 hover:bg-slate-800"
                            }`}
                          >
                            <div
                              // className={`w-2 h-2 rounded-full ${
                              className={`rounded-full ${
                                options.lightingMode === "even"
                                  ? "bg-white animate-pulse"
                                  : "bg-slate-700"
                              }`}
                              style={{
                                height: "10px",
                                width: "15px",
                                marginTop: "-2px"
                              }}
                            />
                            <span>EVEN LIGHTING</span>
                          </button>
                          <button
                            onClick={() =>
                              handleOptionChange("lightingMode", "dramatic")
                            }
                            className={`py-2 px-3 rounded-xl text-[10px] font-bold border transition-all flex items-center justify-center space-x-2 ${
                              options.lightingMode === "dramatic"
                                ? "bg-indigo-600 border-indigo-500 text-white shadow-lg shadow-indigo-500/20"
                                : "bg-slate-950 border-slate-800 text-slate-500 hover:bg-slate-800"
                            }`}
                          >
                            <div
                              // className={`w-2 h-2 rounded-full ${
                              className={`rounded-full ${
                                options.lightingMode === "dramatic"
                                  ? "bg-white animate-pulse"
                                  : "bg-slate-700"
                              }`}
                              style={{
                                height: "10px",
                                width: "15px",
                                marginTop: "-2px"
                              }}
                            />
                            <span>DRAMATIC & CINEMATIC</span>
                          </button>
                        </div>
                        <p className="text-[9px] text-slate-500 font-medium italic">
                          {options.lightingMode === "even"
                            ? "Soft, diffused studio lighting for a clean professional look."
                            : "High-contrast, cinematic lighting with deep shadows and dramatic highlights."}
                        </p>
                      </div>
                    </div>

                    {[
                      { k: "facingCamera", l: "Facing Camera" },
                      { k: "isProfileView", l: "Profile View (Strict)" },
                      { k: "isCloseup", l: "Closeup Shot" },
                      {
                        k: "hasHeadroomAdjust",
                        l: "Adjust Headroom (Space Above Head)"
                      },
                      {
                        k: "removeHandProps",
                        l: "Remove Hand Props (Cups/Phones)"
                      },
                      {
                        k: "removeHandGestures",
                        l: "Remove Hand Gestures (Peace/Waving)"
                      }
                    ].map((item) => (
                      <div key={item.k} className="space-y-2">
                        <label className="flex items-center space-x-3 cursor-pointer group">
                          <input
                            type="checkbox"
                            checked={options[item.k]}
                            onChange={(e) =>
                              handleOptionChange(item.k, e.target.checked)
                            }
                            // className="w-4 h-4 rounded text-indigo-500 border-slate-700 bg-slate-800"
                            className="rounded text-indigo-500 border-slate-700 bg-slate-800"
                            style={{
                              height: "15px",
                              width: "15px",
                              marginTop: "-1px"
                            }}
                          />
                          <span className="text-sm text-slate-400 group-hover:text-slate-200">
                            {item.l}
                          </span>
                        </label>
                        {item.k === "isProfileView" &&
                          options.isProfileView && (
                            <div className="pl-7 pr-2 space-y-4 animate-in slide-in-from-top-1">
                              <div className="space-y-2">
                                <span className="text-[10px] font-bold text-slate-500 uppercase">
                                  View Direction
                                </span>
                                <div className="flex items-center bg-slate-900 rounded-lg p-1 space-x-1">
                                  <button
                                    onClick={() =>
                                      handleOptionChange(
                                        "profileDirection",
                                        "left"
                                      )
                                    }
                                    className={`flex-1 px-3 py-1.5 rounded-md text-[10px] font-bold transition-all ${
                                      options.profileDirection === "left"
                                        ? "bg-indigo-600 text-white shadow-md"
                                        : "text-slate-500 hover:text-slate-300"
                                    }`}
                                  >
                                    LEFT
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleOptionChange(
                                        "profileDirection",
                                        "right"
                                      )
                                    }
                                    className={`flex-1 px-3 py-1.5 rounded-md text-[10px] font-bold transition-all ${
                                      options.profileDirection === "right"
                                        ? "bg-indigo-600 text-white shadow-md"
                                        : "text-slate-500 hover:text-slate-300"
                                    }`}
                                  >
                                    RIGHT
                                  </button>
                                </div>
                              </div>
                              <div className="space-y-2">
                                <div className="flex justify-between items-center text-[10px] font-bold text-slate-500 uppercase">
                                  <span>Profile Angle (0-90°)</span>
                                  <span className="text-indigo-400">
                                    {options.profileAngle}°
                                  </span>
                                </div>
                                <input
                                  type="range"
                                  min="0"
                                  max="90"
                                  value={options.profileAngle}
                                  onChange={(e) =>
                                    handleOptionChange(
                                      "profileAngle",
                                      parseInt(e.target.value)
                                    )
                                  }
                                  className="w-full h-1 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-indigo-500"
                                />
                              </div>
                            </div>
                          )}
                        {item.k === "isCloseup" && options.isCloseup && (
                          <div className="pl-7 pr-2 space-y-1 animate-in slide-in-from-top-1">
                            <div className="flex justify-between items-center text-[10px] font-bold text-slate-500 uppercase">
                              <span>Intensity (Tighter Crop)</span>
                              <span className="text-indigo-400">
                                {options.closeupIntensity}%
                              </span>
                            </div>
                            <input
                              type="range"
                              min="0"
                              max="100"
                              value={options.closeupIntensity}
                              onChange={(e) =>
                                handleOptionChange(
                                  "closeupIntensity",
                                  parseInt(e.target.value)
                                )
                              }
                              className="w-full h-1 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-indigo-500"
                            />
                          </div>
                        )}
                        {item.k === "hasHeadroomAdjust" &&
                          options.hasHeadroomAdjust && (
                            <div className="pl-7 pr-2 space-y-1 animate-in slide-in-from-top-1">
                              <div className="flex justify-between items-center text-[10px] font-bold text-slate-500 uppercase">
                                <span>
                                  {options.headroomLevel > 50
                                    ? "More Headroom"
                                    : options.headroomLevel < 50
                                    ? "Less Headroom"
                                    : "Standard"}
                                </span>
                                <span className="text-indigo-400">
                                  {options.headroomLevel}%
                                </span>
                              </div>
                              <input
                                type="range"
                                min="0"
                                max="100"
                                value={options.headroomLevel}
                                onChange={(e) =>
                                  handleOptionChange(
                                    "headroomLevel",
                                    parseInt(e.target.value)
                                  )
                                }
                                className="w-full h-1 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-indigo-500"
                              />
                            </div>
                          )}
                      </div>
                    ))}

                    <div className="space-y-2">
                      <label className="flex items-center space-x-3 cursor-pointer group">
                        <input
                          type="checkbox"
                          checked={options.subjectBokeh}
                          onChange={(e) =>
                            handleOptionChange("subjectBokeh", e.target.checked)
                          }
                          // className="w-4 h-4 rounded text-indigo-500 border-slate-700 bg-slate-800"
                          className="rounded text-indigo-500 border-slate-700 bg-slate-800"
                          style={{
                            height: "15px",
                            width: "15px",
                            marginTop: "-1px"
                          }}
                        />
                        <span className="text-sm text-slate-400 group-hover:text-slate-200">
                          Subject Bokeh (Cinematic Depth)
                        </span>
                      </label>
                      {options.subjectBokeh && (
                        <div className="pl-7 pr-2 space-y-1 animate-in slide-in-from-top-1">
                          <div className="flex justify-between items-center text-[10px] font-bold text-slate-500 uppercase">
                            <span>Depth Intensity</span>
                            <span className="text-indigo-400">
                              {options.subjectBokehDepth}%
                            </span>
                          </div>
                          <input
                            type="range"
                            min="0"
                            max="100"
                            value={options.subjectBokehDepth}
                            onChange={(e) =>
                              handleOptionChange(
                                "subjectBokehDepth",
                                parseInt(e.target.value)
                              )
                            }
                            className="w-full h-1 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-indigo-500"
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="space-y-6">
                    <div className="flex items-center justify-between">
                      <label className="text-xs font-bold text-slate-500">
                        Background Reference Image (Optional)
                      </label>
                      {hasBgRef && (
                        <button
                          onClick={() => setBgRef(null)}
                          className="text-[10px] text-red-400 hover:underline"
                        >
                          Remove Reference
                        </button>
                      )}
                    </div>

                    <ImageUploader
                      label="Custom Background Reference"
                      description="Upload an image to use as background"
                      image={bgRef}
                      onUpload={(img) =>
                        validateAndSetImage(
                          apikey,
                          img,
                          setBgRef,
                          "Background Reference"
                        )
                      }
                      onClear={() => setBgRef(null)}
                      onError={setError}
                    />
                    <p className="flex flex-col items-center space-y-2 py-2 text-[10px] text-amber-500 font-semibold mt-1 uppercase tracking-tight">
                      Images will be rejected if decent images wearing decent
                      attires are not provided.
                    </p>

                    {hasBgRef && (
                      <div className="bg-indigo-600/10 border border-indigo-500/20 p-3 rounded-xl flex flex-col space-y-2 animate-in slide-in-from-top-1">
                        <div className="flex items-center space-x-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="md:h-4 w-4 text-indigo-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                              clipRule="evenodd"
                            />
                          </svg>
                          <span className="text-[10px] text-indigo-200 font-bold uppercase tracking-tight">
                            Using reference image background. Preset styles
                            disabled.
                          </span>
                        </div>
                        <div className="space-y-2">
                          <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={options.blurBgRef}
                              onChange={(e) =>
                                handleOptionChange(
                                  "blurBgRef",
                                  e.target.checked
                                )
                              }
                              className="w-3.5 h-3.5 rounded text-indigo-500"
                            />
                            <span className="text-xs text-slate-400">
                              Apply Blur to Reference Background
                            </span>
                          </label>
                          {(options.blurBgRef || bgBlur) && (
                            <div className="pl-6 space-y-1 animate-in slide-in-from-top-1">
                              <div className="flex justify-between items-center text-[10px] font-bold text-slate-500 uppercase">
                                <span>Blur Depth</span>
                                <span className="text-indigo-400">
                                  {bgBlurDepth}%
                                </span>
                              </div>
                              <input
                                type="range"
                                min="0"
                                max="100"
                                value={bgBlurDepth}
                                onChange={(e) =>
                                  setBgBlurDepth(parseInt(e.target.value))
                                }
                                className="w-full h-1 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-indigo-500"
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    <div
                      className={`space-y-4 transition-all duration-300 ${
                        isBgSettingsDisabled
                          ? "opacity-30 grayscale pointer-events-none"
                          : "opacity-100"
                      }`}
                    >
                      <div className="flex justify-between items-center px-1">
                        <label className="text-xs font-bold text-slate-500">
                          Preset Background Types
                        </label>
                        {bgType !== "none" && !isBgSettingsDisabled && (
                          <button
                            onClick={() => setBgType("none")}
                            className="text-[10px] text-red-400 hover:underline"
                          >
                            Clear Preset
                          </button>
                        )}
                      </div>

                      <div className="grid grid-cols-2 md:grid-cols-6 gap-2 mb-4">
                        {[
                          "none",
                          "reference",
                          "gradient",
                          "retro",
                          "office",
                          "clean"
                        ].map((t) => (
                          <button
                            key={t}
                            disabled={isBgSettingsDisabled && t !== "reference"}
                            onClick={() => setBgType(t)}
                            className={`py-2 px-1 rounded-lg text-[10px] font-bold border transition-all ${
                              bgType === t
                                ? "bg-indigo-600 border-indigo-500 text-white shadow-lg"
                                : "bg-slate-900 border-slate-800 text-slate-500 hover:bg-slate-800"
                            } ${
                              isBgSettingsDisabled && t !== "reference"
                                ? "opacity-30 grayscale pointer-events-none"
                                : "opacity-100"
                            }`}
                          >
                            {t === "none"
                              ? "KEEP ORIGINAL"
                              : t === "reference"
                              ? "USE REFERENCE"
                              : t.toUpperCase()}
                          </button>
                        ))}
                      </div>

                      {!isBgSettingsDisabled && bgType !== "none" && (
                        <div className="bg-slate-900/40 md:p-4 rounded-2xl border border-slate-800 space-y-4 mb-4">
                          <div className="flex flex-wrap items-center gap-6">
                            <div className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                id="bgNoise"
                                checked={bgNoise}
                                onChange={(e) => setBgNoise(e.target.checked)}
                                // className="w-4 h-4 rounded text-indigo-500 bg-slate-800 border-slate-700"
                                className="rounded text-indigo-500 bg-slate-800 border-slate-700"
                                style={{
                                  height: "15px",
                                  width: "15px",
                                  marginTop: "-5px"
                                }}
                              />
                              <label
                                htmlFor="bgNoise"
                                className="text-[10px] font-bold text-slate-400 uppercase tracking-widest cursor-pointer"
                              >
                                Backdrop Noise (Grain)
                              </label>
                            </div>
                            <div className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                id="bgBlur"
                                checked={bgBlur}
                                onChange={(e) => setBgBlur(e.target.checked)}
                                // className="w-4 h-4 rounded text-indigo-500 bg-slate-800 border-slate-700"
                                className="rounded text-indigo-500 bg-slate-800 border-slate-700"
                                style={{
                                  height: "15px",
                                  width: "15px",
                                  marginTop: "-5px"
                                }}
                              />
                              <label
                                htmlFor="bgBlur"
                                className="text-[10px] font-bold text-slate-400 uppercase tracking-widest cursor-pointer"
                              >
                                Backdrop Blur
                              </label>
                            </div>
                          </div>

                          {(bgNoise || bgBlur) && (
                            <div className="space-y-4 pt-2 border-t border-slate-800 animate-in slide-in-from-top-1">
                              {bgNoise && (
                                <div className="space-y-3">
                                  <div className="flex justify-between items-center">
                                    <div className="flex justify-between items-center text-[10px] font-bold text-slate-500 uppercase flex-1 mr-4">
                                      <span>Noise Intensity</span>
                                      <span className="text-indigo-400">
                                        {noiseLevel}%
                                      </span>
                                    </div>
                                    <label className="flex items-center space-x-2 cursor-pointer">
                                      <input
                                        type="checkbox"
                                        checked={bgNoiseMonochromatic}
                                        onChange={(e) =>
                                          setBgNoiseMonochromatic(
                                            e.target.checked
                                          )
                                        }
                                        className="w-3 h-3 rounded text-indigo-500 bg-slate-800 border-slate-700"
                                      />
                                      <span className="text-[9px] font-bold text-slate-500 uppercase">
                                        Monochromatic
                                      </span>
                                    </label>
                                  </div>
                                  <input
                                    type="range"
                                    min="0"
                                    max="100"
                                    value={noiseLevel}
                                    onChange={(e) =>
                                      setNoiseLevel(parseInt(e.target.value))
                                    }
                                    className="w-full h-1 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-indigo-500"
                                  />
                                </div>
                              )}
                              {bgBlur && (
                                <div className="space-y-3">
                                  <div className="flex justify-between items-center text-[10px] font-bold text-slate-500 uppercase">
                                    <span>Blur Intensity</span>
                                    <span className="text-indigo-400">
                                      {bgBlurDepth}%
                                    </span>
                                  </div>
                                  <input
                                    type="range"
                                    min="0"
                                    max="100"
                                    value={bgBlurDepth}
                                    onChange={(e) =>
                                      setBgBlurDepth(parseInt(e.target.value))
                                    }
                                    className="w-full h-1 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-indigo-500"
                                  />
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      )}

                      {!isBgSettingsDisabled && renderBackgroundPreview()}

                      {bgType === "gradient" && !isBgSettingsDisabled && (
                        <div className="space-y-6 pt-4 animate-in slide-in-from-top-2">
                          <div className="flex items-center justify-between border-b border-slate-800 pb-4">
                            <div className="space-y-1">
                              <span className="text-[10px] font-bold text-slate-500 uppercase">
                                Gradient Type
                              </span>
                              <div className="flex items-center bg-slate-900 rounded-lg p-1 space-x-1">
                                <button
                                  onClick={() => setGradientStyle("linear")}
                                  className={`px-4 py-1.5 rounded-md text-[10px] font-bold transition-all ${
                                    gradientStyle === "linear"
                                      ? "bg-indigo-600 text-white shadow-md"
                                      : "text-slate-500 hover:text-slate-300"
                                  }`}
                                >
                                  LINEAR
                                </button>
                                <button
                                  onClick={() => setGradientStyle("radial")}
                                  className={`px-4 py-1.5 rounded-md text-[10px] font-bold transition-all ${
                                    gradientStyle === "radial"
                                      ? "bg-indigo-600 text-white shadow-md"
                                      : "text-slate-500 hover:text-slate-300"
                                  }`}
                                >
                                  RADIAL
                                </button>
                              </div>
                            </div>

                            <div className="flex items-center space-x-2">
                              {gradientStyle === "linear" && (
                                <div className="space-y-1 mr-4">
                                  <span className="text-[10px] font-bold text-slate-500 uppercase block text-right">
                                    Angle: {gradientAngle}°
                                  </span>
                                  <input
                                    type="range"
                                    min="0"
                                    max="360"
                                    value={gradientAngle}
                                    onChange={(e) =>
                                      setGradientAngle(parseInt(e.target.value))
                                    }
                                    className="w-24 accent-indigo-500"
                                    style={{ marginTop: "-5px" }}
                                  />
                                </div>
                              )}
                              <button
                                onClick={handleReverseGradient}
                                className="bg-slate-800 hover:bg-slate-700 p-2 rounded-lg text-indigo-400 transition-colors"
                                title="Reverse Gradient"
                                style={{ marginTop: "10px" }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="md:h-5 w-5"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                                  />
                                </svg>
                              </button>
                              <button
                                onClick={handleRandomizeGradient}
                                className="bg-slate-800 hover:bg-slate-700 p-2 rounded-lg text-indigo-400 transition-colors"
                                title="Randomize Colors"
                                style={{ marginTop: "10px" }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="md:h-5 w-5"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357-2H15"
                                  />
                                </svg>
                              </button>
                            </div>
                          </div>

                          <div className="space-y-4">
                            <div className="flex justify-between items-center">
                              <span className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">
                                Color Stops (Max 5)
                              </span>
                              <button
                                onClick={addGradientStop}
                                disabled={gradientStops.length >= 5}
                                className="text-[10px] font-bold text-indigo-400 hover:text-indigo-300 disabled:opacity-30 flex items-center space-x-1"
                                style={{ marginTop: "-2px" }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="md:h-3 w-3"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={3}
                                    d="M12 4v16m8-8H4"
                                  />
                                </svg>
                                <span>ADD STOP</span>
                              </button>
                            </div>

                            <div className="space-y-2">
                              {gradientStops.map((stop, index) => (
                                <div
                                  key={stop.id}
                                  className="flex items-center space-x-4 bg-slate-900/50 p-2 rounded-xl border border-slate-800 animate-in slide-in-from-left-1 duration-200"
                                >
                                  <div className="flex items-center space-x-2 flex-1">
                                    <input
                                      type="color"
                                      value={stop.color}
                                      onChange={(e) =>
                                        updateGradientStop(stop.id, {
                                          color: e.target.value
                                        })
                                      }
                                      className="w-8 md:h-8 rounded-full cursor-pointer bg-transparent border-none p-0"
                                    />
                                    <span className="text-[10px] font-mono text-slate-400 uppercase w-16">
                                      {stop.color}
                                    </span>
                                    <input
                                      type="range"
                                      min="0"
                                      max="100"
                                      value={stop.offset}
                                      onChange={(e) =>
                                        updateGradientStop(stop.id, {
                                          offset: parseInt(e.target.value)
                                        })
                                      }
                                      className="flex-1 h-1 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-indigo-500"
                                    />
                                    <span className="text-[10px] font-bold text-slate-500 w-8 text-right">
                                      {stop.offset}%
                                    </span>
                                  </div>
                                  <button
                                    onClick={() => removeGradientStop(stop.id)}
                                    disabled={gradientStops.length <= 2}
                                    className="text-slate-600 hover:text-red-400 disabled:opacity-0 transition-colors"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="md:h-4 w-4"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M6 18L18 6M6 6l12 12"
                                      />
                                    </svg>
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}

                      {(bgType === "retro" || bgType === "clean") &&
                        !isBgSettingsDisabled && (
                          <div className="flex flex-col space-y-4 pt-2 animate-in slide-in-from-left-2">
                            <label className="text-[10px] font-bold text-slate-600 uppercase tracking-widest block">
                              {bgType === "retro"
                                ? "Select Retro Canvas Base Color"
                                : "Select Background Color"}
                            </label>
                            <div className="flex items-center space-x-4 bg-slate-900/50 md:p-4 rounded-2xl border border-slate-800">
                              <input
                                type="color"
                                value={bgColor}
                                disabled={isBgSettingsDisabled}
                                onChange={(e) => setBgColor(e.target.value)}
                                className="w-12 h-12 cursor-pointer bg-slate-800 border-2 border-slate-700 p-1 rounded-xl hover:border-indigo-500 transition-all duration-300"
                              />
                              <div className="flex-col">
                                <span className="text-sm font-mono text-indigo-400 uppercase font-bold">
                                  {bgColor}
                                </span>
                                <span className="text-[9px] ml-5 text-slate-500 font-bold uppercase">
                                  Color Hex Code
                                </span>
                              </div>
                            </div>
                            <p className="text-[9px] text-slate-500 italic px-1 uppercase tracking-tighter">
                              {bgType === "retro"
                                ? "Retro Canvas will feature a vignette and hand-painted texture based on this color."
                                : "Clean Background will be a perfect solid studio color."}
                            </p>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <div className="space-y-4">
              <button
                onClick={handleGenerate}
                disabled={!mainImage || isGenerating}
                className={`w-full py-5 rounded-2xl font-bold text-xl shadow-2xl transition-all ${
                  !mainImage || isGenerating
                    ? "bg-slate-800 text-slate-600 cursor-not-allowed"
                    : "bg-indigo-600 hover:bg-indigo-500 text-white shadow-indigo-600/40 active:scale-[0.98]"
                }`}
              >
                {isGenerating
                  ? "Processing Portrait..."
                  : `Generate Single Portrait for ${
                      countryCode !== "IN" ? 2 : 1
                    } Image Credit${
                      countryCode !== "IN" ? "s" : ""
                    } (Instant Generation)`}
              </button>

              <button
                onClick={() => handleBatchGenerate()}
                disabled={
                  mainImage ||
                  Object.keys(imageFileList).length === 0 ||
                  !isSafe
                }
                className={`w-full py-5 rounded-2xl font-bold text-xl shadow-2xl transition-all ${
                  mainImage ||
                  Object.keys(imageFileList).length === 0 ||
                  !isSafe
                    ? "bg-slate-800 text-slate-600 cursor-not-allowed"
                    : "bg-indigo-600 hover:bg-indigo-500 text-white shadow-indigo-600/40 active:scale-[0.98]"
                }`}
              >
                Generate Professional Headhots for{" "}
                {Object.keys(imageFileList).length} chosen Files (Batch Process)
              </button>
            </div>

            {error && (
              <div className="p-4 bg-red-500/10 border border-red-500/20 rounded-xl text-red-200 text-sm animate-shake">
                {error}
              </div>
            )}
          </div>

          <div
            className={`lg:col-span-4 ${
              activeTab === "result" || !mobile ? "block" : "hidden lg:block"
            }`}
          >
            <div className="lg:sticky lg:top-28 space-y-6">
              <h2 className="text-lg font-bold flex items-center space-x-2">
                <span className="text-indigo-400">03</span>
                <span style={{ color: "white" }}>Studio Result</span>
              </h2>
              <div className="glass rounded-[2rem] md:rounded-[3rem] min-h-[400px] md:min-h-[500px] flex items-center justify-center relative overflow-hidden group shadow-2xl border-indigo-500/10">
                {!isSafe || isGenerating ? (
                  <div className="flex flex-col items-center p-8 text-center space-y-6">
                    <div
                      className="relative"
                      style={{ width: "50px", height: "50px" }}
                    >
                      {/* <div className="absolute inset-0 border-4 border-indigo-500/20 rounded-full"></div> */}
                      <div className="absolute inset-0 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin"></div>
                    </div>
                    <div className="max-w-[250px]">
                      <p className="text-xl font-bold text-indigo-400 animate-pulse">
                        {loadingMessage}
                      </p>
                      <p className="text-[10px] text-slate-500 mt-2 uppercase tracking-widest font-bold">
                        Gemini 3 Pro Render Engine
                      </p>
                      <p className="text-[10px] text-slate-500 mt-2 uppercase tracking-widest font-bold">
                        Prompt Engineering by aiComposz
                      </p>
                      <p className="text-[9px] text-slate-600 mt-1 italic uppercase">
                        Note: Pro images are generated at high{" "}
                        {is4K ? "4k" : "2K"} resolution and take longer than
                        text tasks.
                      </p>
                    </div>
                  </div>
                ) : result ? (
                  <div className="w-full h-full flex flex-col items-center md:p-4">
                    <img
                      src={result.imageUrl}
                      alt="Result"
                      className="w-full h-auto rounded-[2rem] shadow-2xl"
                    />

                    {/* <div className="absolute inset-x-8 bottom-32 flex space-x-3 opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-2 group-hover:translate-y-0"> */}
                    <div
                      className={
                        mobile
                          ? "inset-x-8 bottom-6 flex space-x-3 opacity-100"
                          : "inset-x-8 bottom-32 flex space-x-3 opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-2 group-hover:translate-y-0"
                      }
                    >
                      <button
                        onClick={handleDownload}
                        // className="flex-1 bg-white text-slate-950 font-bold py-3 rounded-2xl hover:bg-slate-100 flex items-center justify-center space-x-2 shadow-xl"
                        className="flex-1 bg-white text-slate-950 font-bold py-3 rounded-2xl flex items-center justify-center space-x-2 shadow-xl"
                        style={{
                          marginTop: "10px",
                          paddingRight: "10px",
                          paddingLeft: "10px",
                          bottom: "8rem"
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="md:h-5 md:w-5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                        <span>Download</span>
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="text-center p-12 text-slate-600 space-y-4">
                    {/* <div className="w-20 h-20 border-2 border-dashed border-slate-800 rounded-full mx-auto flex items-center justify-center"> */}
                    <div
                      className="border-2 border-dashed border-slate-800 rounded-full mx-auto flex items-center justify-center"
                      style={{ height: "100px", width: "100px" }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        // className="md:h-10 md:w-10 opacity-20"
                        className="opacity-20"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        style={{ height: "50px", width: "50px" }}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2-2v12a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                    <p className="font-bold text-slate-500">
                      Awaiting Generation
                    </p>
                    <p className="text-xs max-w-[200px] mx-auto opacity-40">
                      Upload your source photo and define your style above.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>

        {/* Modals */}
        <StyleBuilderModal
          apikey={apikey}
          isOpen={isStyleBuilderOpen}
          onClose={() => setIsStyleBuilderOpen(false)}
          isGroupMode={hasGroupImages}
          target={hasGroupImages ? "group" : activeStyleBuilderTarget}
          onTargetChange={setActiveStyleBuilderTarget}
          textOnlyDirective={
            hasGroupImages
              ? groupTextOnlyDirective
              : activeStyleBuilderTarget === "male"
              ? maleTextOnlyDirective
              : femaleTextOnlyDirective
          }
          onTextOnlyDirectiveChange={(val) => {
            if (hasGroupImages) {
              setGroupTextOnlyDirective(val);
            } else if (activeStyleBuilderTarget === "male") {
              setMaleTextOnlyDirective(val);
            } else {
              setFemaleTextOnlyDirective(val);
            }
          }}
          snippets={
            hasGroupImages
              ? groupStyleSnippets
              : activeStyleBuilderTarget === "male"
              ? maleStyleSnippets
              : femaleStyleSnippets
          }
          onSnippetsChange={(newSnippets) => {
            if (hasGroupImages) {
              setGroupStyleSnippets(newSnippets);
            } else if (activeStyleBuilderTarget === "male") {
              setMaleStyleSnippets(newSnippets);
            } else {
              setFemaleStyleSnippets(newSnippets);
            }
          }}
          globalCompositionSnippet={globalCompositionSnippet}
          onGlobalCompositionSnippetChange={(snippet) => {
            setGlobalCompositionSnippet(snippet);
            if (snippet) {
              // Automatically set all group members to 'clone' posture when a group reference is uploaded/changed
              setGroupMembers((prev) =>
                prev.map((m) => ({ ...m, posture: "clone" }))
              );
            }
          }}
          onFinalize={(image, target) => {
            if (target === "male") {
              validateAndSetImage(
                apikey,
                image,
                setMaleRef,
                "Male Reference Catalogue"
              );
            } else if (target === "female") {
              validateAndSetImage(
                apikey,
                image,
                setFemaleRef,
                "Female Reference Catalogue"
              );
            } else if (target === "group") {
              validateAndSetImage(
                apikey,
                image,
                setGroupStyleRef,
                "Group Style Reference Catalogue"
              );
              setGroupMembers((prev) =>
                prev.map((m) => ({ ...m, posture: "clone" }))
              );
            }
          }}
          availableIdentifiers={groupMembers
            .map((m) => m.label)
            .filter(Boolean)}
          mobile={mobile}
        />

        <GroupUploaderModal
          isOpen={isGroupModalOpen}
          onClose={() => setIsGroupModalOpen(false)}
          members={groupMembers}
          onUploadMemberImage={handleUploadMemberImage}
          onUpdateMember={handleUpdateGroupMember}
          globalCompositionSnippet={globalCompositionSnippet}
        />

        <TermsModal
          isOpen={isTermsModalOpen}
          onClose={() => setIsTermsModalOpen(false)}
        />

        <FAQModal
          isOpen={isFAQModalOpen}
          onClose={() => setIsFAQModalOpen(false)}
          mobile={mobile}
        />

        <DisclaimerModal
          isOpen={isDisclaimerModalOpen}
          onClose={() => setIsDisclaimerModalOpen(false)}
        />
        {/* Sticky Mobile Generate Button */}
        <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 md:p-4 bg-slate-950/90 backdrop-blur-xl border-t border-slate-800 flex flex-col space-y-3">
          {error && (
            <div className="p-2 bg-red-500/10 border border-red-500/20 rounded-lg text-red-200 text-[10px] animate-shake text-center">
              {error}
            </div>
          )}
          <button
            onClick={hasGroupImages ? handleGenerateGroup : handleGenerate}
            disabled={(!mainImage && !hasGroupImages) || isGenerating}
            className={`w-full py-4 rounded-xl font-bold text-lg shadow-2xl transition-all flex items-center justify-center space-x-3 ${
              (!mainImage && !hasGroupImages) || isGenerating
                ? "bg-slate-800 text-slate-600"
                : hasGroupImages
                ? "bg-rose-600 text-white"
                : "bg-indigo-600 text-white"
            }`}
          >
            {isGenerating ? (
              <React.Fragment>
                <div className="w-20 h-20 border-2 border-white/20 border-t-white rounded-full animate-spin"></div>
                <span>Processing...</span>
              </React.Fragment>
            ) : (
              <span>
                {hasGroupImages
                  ? `Generate Group Portrait (${
                      countryCode !== "IN" ? 3 : 2
                    } Image Credit${countryCode !== "IN" ? "s" : ""})`
                  : `Generate Single Portrait for ${
                      countryCode !== "IN" ? 2 : 1
                    } Image Credit${
                      countryCode !== "IN" ? "s" : ""
                    } (Instant Generation)`}
              </span>
            )}
          </button>
        </div>

        <Modal
          dialogClassName="modal-90w"
          show={isEnhanceModal}
          size="lg"
          centered="true"
          onHide={showModal}
          style={{ color: "black" }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Enhance Images</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table style={{ border: "1px solid black" }}>
              <thead
                style={{
                  border: "1px solid black",
                  fontSize: "20px",
                  fontWeight: "bold",
                  margin: "10px"
                }}
              >
                Selected Images
              </thead>
              <tbody>
                {Object.keys(imageFileList).map((file_path, index) => {
                  return (
                    <tr
                      key={index}
                      style={{ border: "1px solid black", margin: "20px" }}
                    >
                      <td style={{ marginLeft: "15px" }}>
                        {index + 1}
                        {") "} {file_path}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Modal.Body>
        </Modal>

        <div id="loading-overlay" className="hidden">
          <div id="mySpinner" style={{ display: "", zIndex: "9999" }}>
            <SPLoader></SPLoader>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default GenPortraits;
